import * as p from "react";
import _o, { useState as jo, forwardRef as Do, createElement as Fr, createContext as es, useContext as ts, useLayoutEffect as rs } from "react";
import * as Io from "react-dom";
import ns from "react-dom";
var Mt = { exports: {} }, Ot = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nn;
function os() {
  if (Nn) return Ot;
  Nn = 1;
  var e = _o, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, u) {
    var c, f = {}, d = null, g = null;
    u !== void 0 && (d = "" + u), l.key !== void 0 && (d = "" + l.key), l.ref !== void 0 && (g = l.ref);
    for (c in l) n.call(l, c) && !i.hasOwnProperty(c) && (f[c] = l[c]);
    if (s && s.defaultProps) for (c in l = s.defaultProps, l) f[c] === void 0 && (f[c] = l[c]);
    return { $$typeof: t, type: s, key: d, ref: g, props: f, _owner: o.current };
  }
  return Ot.Fragment = r, Ot.jsx = a, Ot.jsxs = a, Ot;
}
var Pt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ln;
function is() {
  return Ln || (Ln = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = _o, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), b = Symbol.iterator, m = "@@iterator";
    function w(h) {
      if (h === null || typeof h != "object")
        return null;
      var R = b && h[b] || h[m];
      return typeof R == "function" ? R : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(h) {
      {
        for (var R = arguments.length, A = new Array(R > 1 ? R - 1 : 0), D = 1; D < R; D++)
          A[D - 1] = arguments[D];
        C("error", h, A);
      }
    }
    function C(h, R, A) {
      {
        var D = v.ReactDebugCurrentFrame, U = D.getStackAddendum();
        U !== "" && (R += "%s", A = A.concat([U]));
        var G = A.map(function(z) {
          return String(z);
        });
        G.unshift("Warning: " + R), Function.prototype.apply.call(console[h], console, G);
      }
    }
    var S = !1, O = !1, T = !1, k = !1, E = !1, _;
    _ = Symbol.for("react.module.reference");
    function j(h) {
      return !!(typeof h == "string" || typeof h == "function" || h === n || h === i || E || h === o || h === u || h === c || k || h === g || S || O || T || typeof h == "object" && h !== null && (h.$$typeof === d || h.$$typeof === f || h.$$typeof === a || h.$$typeof === s || h.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      h.$$typeof === _ || h.getModuleId !== void 0));
    }
    function V(h, R, A) {
      var D = h.displayName;
      if (D)
        return D;
      var U = R.displayName || R.name || "";
      return U !== "" ? A + "(" + U + ")" : A;
    }
    function Y(h) {
      return h.displayName || "Context";
    }
    function B(h) {
      if (h == null)
        return null;
      if (typeof h.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof h == "function")
        return h.displayName || h.name || null;
      if (typeof h == "string")
        return h;
      switch (h) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case s:
            var R = h;
            return Y(R) + ".Consumer";
          case a:
            var A = h;
            return Y(A._context) + ".Provider";
          case l:
            return V(h, h.render, "ForwardRef");
          case f:
            var D = h.displayName || null;
            return D !== null ? D : B(h.type) || "Memo";
          case d: {
            var U = h, G = U._payload, z = U._init;
            try {
              return B(z(G));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var I = Object.assign, K = 0, F, $, P, X, ne, ie, ke;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function J() {
      {
        if (K === 0) {
          F = console.log, $ = console.info, P = console.warn, X = console.error, ne = console.group, ie = console.groupCollapsed, ke = console.groupEnd;
          var h = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: h,
            log: h,
            warn: h,
            error: h,
            group: h,
            groupCollapsed: h,
            groupEnd: h
          });
        }
        K++;
      }
    }
    function Ce() {
      {
        if (K--, K === 0) {
          var h = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: I({}, h, {
              value: F
            }),
            info: I({}, h, {
              value: $
            }),
            warn: I({}, h, {
              value: P
            }),
            error: I({}, h, {
              value: X
            }),
            group: I({}, h, {
              value: ne
            }),
            groupCollapsed: I({}, h, {
              value: ie
            }),
            groupEnd: I({}, h, {
              value: ke
            })
          });
        }
        K < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var de = v.ReactCurrentDispatcher, H;
    function pe(h, R, A) {
      {
        if (H === void 0)
          try {
            throw Error();
          } catch (U) {
            var D = U.stack.trim().match(/\n( *(at )?)/);
            H = D && D[1] || "";
          }
        return `
` + H + h;
      }
    }
    var ge = !1, ae;
    {
      var le = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new le();
    }
    function he(h, R) {
      if (!h || ge)
        return "";
      {
        var A = ae.get(h);
        if (A !== void 0)
          return A;
      }
      var D;
      ge = !0;
      var U = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var G;
      G = de.current, de.current = null, J();
      try {
        if (R) {
          var z = function() {
            throw Error();
          };
          if (Object.defineProperty(z.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(z, []);
            } catch (me) {
              D = me;
            }
            Reflect.construct(h, [], z);
          } else {
            try {
              z.call();
            } catch (me) {
              D = me;
            }
            h.call(z.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (me) {
            D = me;
          }
          h();
        }
      } catch (me) {
        if (me && D && typeof me.stack == "string") {
          for (var W = me.stack.split(`
`), ce = D.stack.split(`
`), Z = W.length - 1, ee = ce.length - 1; Z >= 1 && ee >= 0 && W[Z] !== ce[ee]; )
            ee--;
          for (; Z >= 1 && ee >= 0; Z--, ee--)
            if (W[Z] !== ce[ee]) {
              if (Z !== 1 || ee !== 1)
                do
                  if (Z--, ee--, ee < 0 || W[Z] !== ce[ee]) {
                    var we = `
` + W[Z].replace(" at new ", " at ");
                    return h.displayName && we.includes("<anonymous>") && (we = we.replace("<anonymous>", h.displayName)), typeof h == "function" && ae.set(h, we), we;
                  }
                while (Z >= 1 && ee >= 0);
              break;
            }
        }
      } finally {
        ge = !1, de.current = G, Ce(), Error.prepareStackTrace = U;
      }
      var ct = h ? h.displayName || h.name : "", nt = ct ? pe(ct) : "";
      return typeof h == "function" && ae.set(h, nt), nt;
    }
    function Ae(h, R, A) {
      return he(h, !1);
    }
    function tt(h) {
      var R = h.prototype;
      return !!(R && R.isReactComponent);
    }
    function st(h, R, A) {
      if (h == null)
        return "";
      if (typeof h == "function")
        return he(h, tt(h));
      if (typeof h == "string")
        return pe(h);
      switch (h) {
        case u:
          return pe("Suspense");
        case c:
          return pe("SuspenseList");
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case l:
            return Ae(h.render);
          case f:
            return st(h.type, R, A);
          case d: {
            var D = h, U = D._payload, G = D._init;
            try {
              return st(G(U), R, A);
            } catch {
            }
          }
        }
      return "";
    }
    var rt = Object.prototype.hasOwnProperty, Dt = {}, It = v.ReactDebugCurrentFrame;
    function Be(h) {
      if (h) {
        var R = h._owner, A = st(h.type, h._source, R ? R.type : null);
        It.setExtraStackFrame(A);
      } else
        It.setExtraStackFrame(null);
    }
    function La(h, R, A, D, U) {
      {
        var G = Function.call.bind(rt);
        for (var z in h)
          if (G(h, z)) {
            var W = void 0;
            try {
              if (typeof h[z] != "function") {
                var ce = Error((D || "React class") + ": " + A + " type `" + z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[z] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ce.name = "Invariant Violation", ce;
              }
              W = h[z](R, z, D, A, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Z) {
              W = Z;
            }
            W && !(W instanceof Error) && (Be(U), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", D || "React class", A, z, typeof W), Be(null)), W instanceof Error && !(W.message in Dt) && (Dt[W.message] = !0, Be(U), y("Failed %s type: %s", A, W.message), Be(null));
          }
      }
    }
    var _a = Array.isArray;
    function xr(h) {
      return _a(h);
    }
    function ja(h) {
      {
        var R = typeof Symbol == "function" && Symbol.toStringTag, A = R && h[Symbol.toStringTag] || h.constructor.name || "Object";
        return A;
      }
    }
    function Da(h) {
      try {
        return yn(h), !1;
      } catch {
        return !0;
      }
    }
    function yn(h) {
      return "" + h;
    }
    function wn(h) {
      if (Da(h))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ja(h)), yn(h);
    }
    var xn = v.ReactCurrentOwner, Ia = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Sn, Cn;
    function Ma(h) {
      if (rt.call(h, "ref")) {
        var R = Object.getOwnPropertyDescriptor(h, "ref").get;
        if (R && R.isReactWarning)
          return !1;
      }
      return h.ref !== void 0;
    }
    function Fa(h) {
      if (rt.call(h, "key")) {
        var R = Object.getOwnPropertyDescriptor(h, "key").get;
        if (R && R.isReactWarning)
          return !1;
      }
      return h.key !== void 0;
    }
    function $a(h, R) {
      typeof h.ref == "string" && xn.current;
    }
    function Wa(h, R) {
      {
        var A = function() {
          Sn || (Sn = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", R));
        };
        A.isReactWarning = !0, Object.defineProperty(h, "key", {
          get: A,
          configurable: !0
        });
      }
    }
    function za(h, R) {
      {
        var A = function() {
          Cn || (Cn = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", R));
        };
        A.isReactWarning = !0, Object.defineProperty(h, "ref", {
          get: A,
          configurable: !0
        });
      }
    }
    var Ba = function(h, R, A, D, U, G, z) {
      var W = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: h,
        key: R,
        ref: A,
        props: z,
        // Record the component responsible for creating this element.
        _owner: G
      };
      return W._store = {}, Object.defineProperty(W._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(W, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: D
      }), Object.defineProperty(W, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: U
      }), Object.freeze && (Object.freeze(W.props), Object.freeze(W)), W;
    };
    function Va(h, R, A, D, U) {
      {
        var G, z = {}, W = null, ce = null;
        A !== void 0 && (wn(A), W = "" + A), Fa(R) && (wn(R.key), W = "" + R.key), Ma(R) && (ce = R.ref, $a(R, U));
        for (G in R)
          rt.call(R, G) && !Ia.hasOwnProperty(G) && (z[G] = R[G]);
        if (h && h.defaultProps) {
          var Z = h.defaultProps;
          for (G in Z)
            z[G] === void 0 && (z[G] = Z[G]);
        }
        if (W || ce) {
          var ee = typeof h == "function" ? h.displayName || h.name || "Unknown" : h;
          W && Wa(z, ee), ce && za(z, ee);
        }
        return Ba(h, W, ce, U, D, xn.current, z);
      }
    }
    var Sr = v.ReactCurrentOwner, Rn = v.ReactDebugCurrentFrame;
    function lt(h) {
      if (h) {
        var R = h._owner, A = st(h.type, h._source, R ? R.type : null);
        Rn.setExtraStackFrame(A);
      } else
        Rn.setExtraStackFrame(null);
    }
    var Cr;
    Cr = !1;
    function Rr(h) {
      return typeof h == "object" && h !== null && h.$$typeof === t;
    }
    function On() {
      {
        if (Sr.current) {
          var h = B(Sr.current.type);
          if (h)
            return `

Check the render method of \`` + h + "`.";
        }
        return "";
      }
    }
    function Ha(h) {
      return "";
    }
    var Pn = {};
    function Ua(h) {
      {
        var R = On();
        if (!R) {
          var A = typeof h == "string" ? h : h.displayName || h.name;
          A && (R = `

Check the top-level render call using <` + A + ">.");
        }
        return R;
      }
    }
    function En(h, R) {
      {
        if (!h._store || h._store.validated || h.key != null)
          return;
        h._store.validated = !0;
        var A = Ua(R);
        if (Pn[A])
          return;
        Pn[A] = !0;
        var D = "";
        h && h._owner && h._owner !== Sr.current && (D = " It was passed a child from " + B(h._owner.type) + "."), lt(h), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', A, D), lt(null);
      }
    }
    function kn(h, R) {
      {
        if (typeof h != "object")
          return;
        if (xr(h))
          for (var A = 0; A < h.length; A++) {
            var D = h[A];
            Rr(D) && En(D, R);
          }
        else if (Rr(h))
          h._store && (h._store.validated = !0);
        else if (h) {
          var U = w(h);
          if (typeof U == "function" && U !== h.entries)
            for (var G = U.call(h), z; !(z = G.next()).done; )
              Rr(z.value) && En(z.value, R);
        }
      }
    }
    function Ya(h) {
      {
        var R = h.type;
        if (R == null || typeof R == "string")
          return;
        var A;
        if (typeof R == "function")
          A = R.propTypes;
        else if (typeof R == "object" && (R.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        R.$$typeof === f))
          A = R.propTypes;
        else
          return;
        if (A) {
          var D = B(R);
          La(A, h.props, "prop", D, h);
        } else if (R.PropTypes !== void 0 && !Cr) {
          Cr = !0;
          var U = B(R);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", U || "Unknown");
        }
        typeof R.getDefaultProps == "function" && !R.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ka(h) {
      {
        for (var R = Object.keys(h.props), A = 0; A < R.length; A++) {
          var D = R[A];
          if (D !== "children" && D !== "key") {
            lt(h), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", D), lt(null);
            break;
          }
        }
        h.ref !== null && (lt(h), y("Invalid attribute `ref` supplied to `React.Fragment`."), lt(null));
      }
    }
    var An = {};
    function Tn(h, R, A, D, U, G) {
      {
        var z = j(h);
        if (!z) {
          var W = "";
          (h === void 0 || typeof h == "object" && h !== null && Object.keys(h).length === 0) && (W += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ce = Ha();
          ce ? W += ce : W += On();
          var Z;
          h === null ? Z = "null" : xr(h) ? Z = "array" : h !== void 0 && h.$$typeof === t ? (Z = "<" + (B(h.type) || "Unknown") + " />", W = " Did you accidentally export a JSX literal instead of a component?") : Z = typeof h, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Z, W);
        }
        var ee = Va(h, R, A, U, G);
        if (ee == null)
          return ee;
        if (z) {
          var we = R.children;
          if (we !== void 0)
            if (D)
              if (xr(we)) {
                for (var ct = 0; ct < we.length; ct++)
                  kn(we[ct], h);
                Object.freeze && Object.freeze(we);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(we, h);
        }
        if (rt.call(R, "key")) {
          var nt = B(h), me = Object.keys(R).filter(function(Qa) {
            return Qa !== "key";
          }), Or = me.length > 0 ? "{key: someKey, " + me.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!An[nt + Or]) {
            var Za = me.length > 0 ? "{" + me.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Or, nt, Za, nt), An[nt + Or] = !0;
          }
        }
        return h === n ? Ka(ee) : Ya(ee), ee;
      }
    }
    function Ga(h, R, A) {
      return Tn(h, R, A, !0);
    }
    function Xa(h, R, A) {
      return Tn(h, R, A, !1);
    }
    var Ja = Xa, qa = Ga;
    Pt.Fragment = n, Pt.jsx = Ja, Pt.jsxs = qa;
  })()), Pt;
}
var _n;
function as() {
  return _n || (_n = 1, process.env.NODE_ENV === "production" ? Mt.exports = os() : Mt.exports = is()), Mt.exports;
}
var x = as();
function jn(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Mo(...e) {
  return (t) => {
    let r = !1;
    const n = e.map((o) => {
      const i = jn(o, t);
      return !r && typeof i == "function" && (r = !0), i;
    });
    if (r)
      return () => {
        for (let o = 0; o < n.length; o++) {
          const i = n[o];
          typeof i == "function" ? i() : jn(e[o], null);
        }
      };
  };
}
function oe(...e) {
  return p.useCallback(Mo(...e), e);
}
// @__NO_SIDE_EFFECTS__
function Jr(e) {
  const t = /* @__PURE__ */ ls(e), r = p.forwardRef((n, o) => {
    const { children: i, ...a } = n, s = p.Children.toArray(i), l = s.find(us);
    if (l) {
      const u = l.props.children, c = s.map((f) => f === l ? p.Children.count(u) > 1 ? p.Children.only(null) : p.isValidElement(u) ? u.props.children : null : f);
      return /* @__PURE__ */ x.jsx(t, { ...a, ref: o, children: p.isValidElement(u) ? p.cloneElement(u, void 0, c) : null });
    }
    return /* @__PURE__ */ x.jsx(t, { ...a, ref: o, children: i });
  });
  return r.displayName = `${e}.Slot`, r;
}
var ss = /* @__PURE__ */ Jr("Slot");
// @__NO_SIDE_EFFECTS__
function ls(e) {
  const t = p.forwardRef((r, n) => {
    const { children: o, ...i } = r;
    if (p.isValidElement(o)) {
      const a = ds(o), s = fs(i, o.props);
      return o.type !== p.Fragment && (s.ref = n ? Mo(n, a) : a), p.cloneElement(o, s);
    }
    return p.Children.count(o) > 1 ? p.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Fo = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function cs(e) {
  const t = ({ children: r }) => /* @__PURE__ */ x.jsx(x.Fragment, { children: r });
  return t.displayName = `${e}.Slottable`, t.__radixId = Fo, t;
}
function us(e) {
  return p.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Fo;
}
function fs(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? o && i ? r[n] = (...s) => {
      const l = i(...s);
      return o(...s), l;
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...i } : n === "className" && (r[n] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function ds(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
function $o(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = $o(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function Wo() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = $o(e)) && (n && (n += " "), n += t);
  return n;
}
const Dn = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, In = Wo, ps = (e, t) => (r) => {
  var n;
  if ((t == null ? void 0 : t.variants) == null) return In(e, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  const { variants: o, defaultVariants: i } = t, a = Object.keys(o).map((u) => {
    const c = r == null ? void 0 : r[u], f = i == null ? void 0 : i[u];
    if (c === null) return null;
    const d = Dn(c) || Dn(f);
    return o[u][d];
  }), s = r && Object.entries(r).reduce((u, c) => {
    let [f, d] = c;
    return d === void 0 || (u[f] = d), u;
  }, {}), l = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((u, c) => {
    let { class: f, className: d, ...g } = c;
    return Object.entries(g).every((b) => {
      let [m, w] = b;
      return Array.isArray(w) ? w.includes({
        ...i,
        ...s
      }[m]) : {
        ...i,
        ...s
      }[m] === w;
    }) ? [
      ...u,
      f,
      d
    ] : u;
  }, []);
  return In(e, a, l, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
}, gs = ps(
  "inline-flex rounded-[24px] items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 rounded-[var(--button-border-radius)]",
  {
    variants: {
      variant: {
        default: "btn-primary-custom text-primary-foreground hover:opacity-50",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: " btn-secondary-custom border font-semibold",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), qr = "-", hs = (e) => {
  const t = vs(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (a) => {
      const s = a.split(qr);
      return s[0] === "" && s.length !== 1 && s.shift(), zo(s, t) || ms(a);
    },
    getConflictingClassGroupIds: (a, s) => {
      const l = r[a] || [];
      return s && n[a] ? [...l, ...n[a]] : l;
    }
  };
}, zo = (e, t) => {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), o = n ? zo(e.slice(1), n) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(qr);
  return (a = t.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : a.classGroupId;
}, Mn = /^\[(.+)\]$/, ms = (e) => {
  if (Mn.test(e)) {
    const t = Mn.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, vs = (e) => {
  const {
    theme: t,
    classGroups: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const o in r)
    $r(r[o], n, o, t);
  return n;
}, $r = (e, t, r, n) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : Fn(t, o);
      i.classGroupId = r;
      return;
    }
    if (typeof o == "function") {
      if (bs(o)) {
        $r(o(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: r
      });
      return;
    }
    Object.entries(o).forEach(([i, a]) => {
      $r(a, Fn(t, i), r, n);
    });
  });
}, Fn = (e, t) => {
  let r = e;
  return t.split(qr).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, bs = (e) => e.isThemeGetter, ys = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const o = (i, a) => {
    r.set(i, a), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let a = r.get(i);
      if (a !== void 0)
        return a;
      if ((a = n.get(i)) !== void 0)
        return o(i, a), a;
    },
    set(i, a) {
      r.has(i) ? r.set(i, a) : o(i, a);
    }
  };
}, Wr = "!", zr = ":", ws = zr.length, xs = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: r
  } = e;
  let n = (o) => {
    const i = [];
    let a = 0, s = 0, l = 0, u;
    for (let b = 0; b < o.length; b++) {
      let m = o[b];
      if (a === 0 && s === 0) {
        if (m === zr) {
          i.push(o.slice(l, b)), l = b + ws;
          continue;
        }
        if (m === "/") {
          u = b;
          continue;
        }
      }
      m === "[" ? a++ : m === "]" ? a-- : m === "(" ? s++ : m === ")" && s--;
    }
    const c = i.length === 0 ? o : o.substring(l), f = Ss(c), d = f !== c, g = u && u > l ? u - l : void 0;
    return {
      modifiers: i,
      hasImportantModifier: d,
      baseClassName: f,
      maybePostfixModifierPosition: g
    };
  };
  if (t) {
    const o = t + zr, i = n;
    n = (a) => a.startsWith(o) ? i(a.substring(o.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: a,
      maybePostfixModifierPosition: void 0
    };
  }
  if (r) {
    const o = n;
    n = (i) => r({
      className: i,
      parseClassName: o
    });
  }
  return n;
}, Ss = (e) => e.endsWith(Wr) ? e.substring(0, e.length - 1) : e.startsWith(Wr) ? e.substring(1) : e, Cs = (e) => {
  const t = Object.fromEntries(e.orderSensitiveModifiers.map((n) => [n, !0]));
  return (n) => {
    if (n.length <= 1)
      return n;
    const o = [];
    let i = [];
    return n.forEach((a) => {
      a[0] === "[" || t[a] ? (o.push(...i.sort(), a), i = []) : i.push(a);
    }), o.push(...i.sort()), o;
  };
}, Rs = (e) => ({
  cache: ys(e.cacheSize),
  parseClassName: xs(e),
  sortModifiers: Cs(e),
  ...hs(e)
}), Os = /\s+/, Ps = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: o,
    sortModifiers: i
  } = t, a = [], s = e.trim().split(Os);
  let l = "";
  for (let u = s.length - 1; u >= 0; u -= 1) {
    const c = s[u], {
      isExternal: f,
      modifiers: d,
      hasImportantModifier: g,
      baseClassName: b,
      maybePostfixModifierPosition: m
    } = r(c);
    if (f) {
      l = c + (l.length > 0 ? " " + l : l);
      continue;
    }
    let w = !!m, v = n(w ? b.substring(0, m) : b);
    if (!v) {
      if (!w) {
        l = c + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (v = n(b), !v) {
        l = c + (l.length > 0 ? " " + l : l);
        continue;
      }
      w = !1;
    }
    const y = i(d).join(":"), C = g ? y + Wr : y, S = C + v;
    if (a.includes(S))
      continue;
    a.push(S);
    const O = o(v, w);
    for (let T = 0; T < O.length; ++T) {
      const k = O[T];
      a.push(C + k);
    }
    l = c + (l.length > 0 ? " " + l : l);
  }
  return l;
};
function Es() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = Bo(t)) && (n && (n += " "), n += r);
  return n;
}
const Bo = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = Bo(e[n])) && (r && (r += " "), r += t);
  return r;
};
function ks(e, ...t) {
  let r, n, o, i = a;
  function a(l) {
    const u = t.reduce((c, f) => f(c), e());
    return r = Rs(u), n = r.cache.get, o = r.cache.set, i = s, s(l);
  }
  function s(l) {
    const u = n(l);
    if (u)
      return u;
    const c = Ps(l, r);
    return o(l, c), c;
  }
  return function() {
    return i(Es.apply(null, arguments));
  };
}
const te = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, Vo = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Ho = /^\((?:(\w[\w-]*):)?(.+)\)$/i, As = /^\d+\/\d+$/, Ts = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Ns = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Ls = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, _s = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, js = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ut = (e) => As.test(e), M = (e) => !!e && !Number.isNaN(Number(e)), Ge = (e) => !!e && Number.isInteger(Number(e)), Pr = (e) => e.endsWith("%") && M(e.slice(0, -1)), Ve = (e) => Ts.test(e), Ds = () => !0, Is = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Ns.test(e) && !Ls.test(e)
), Uo = () => !1, Ms = (e) => _s.test(e), Fs = (e) => js.test(e), $s = (e) => !N(e) && !L(e), Ws = (e) => xt(e, Go, Uo), N = (e) => Vo.test(e), ot = (e) => xt(e, Xo, Is), Er = (e) => xt(e, Us, M), $n = (e) => xt(e, Yo, Uo), zs = (e) => xt(e, Ko, Fs), Ft = (e) => xt(e, Jo, Ms), L = (e) => Ho.test(e), Et = (e) => St(e, Xo), Bs = (e) => St(e, Ys), Wn = (e) => St(e, Yo), Vs = (e) => St(e, Go), Hs = (e) => St(e, Ko), $t = (e) => St(e, Jo, !0), xt = (e, t, r) => {
  const n = Vo.exec(e);
  return n ? n[1] ? t(n[1]) : r(n[2]) : !1;
}, St = (e, t, r = !1) => {
  const n = Ho.exec(e);
  return n ? n[1] ? t(n[1]) : r : !1;
}, Yo = (e) => e === "position" || e === "percentage", Ko = (e) => e === "image" || e === "url", Go = (e) => e === "length" || e === "size" || e === "bg-size", Xo = (e) => e === "length", Us = (e) => e === "number", Ys = (e) => e === "family-name", Jo = (e) => e === "shadow", Ks = () => {
  const e = te("color"), t = te("font"), r = te("text"), n = te("font-weight"), o = te("tracking"), i = te("leading"), a = te("breakpoint"), s = te("container"), l = te("spacing"), u = te("radius"), c = te("shadow"), f = te("inset-shadow"), d = te("text-shadow"), g = te("drop-shadow"), b = te("blur"), m = te("perspective"), w = te("aspect"), v = te("ease"), y = te("animate"), C = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], S = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], O = () => [...S(), L, N], T = () => ["auto", "hidden", "clip", "visible", "scroll"], k = () => ["auto", "contain", "none"], E = () => [L, N, l], _ = () => [ut, "full", "auto", ...E()], j = () => [Ge, "none", "subgrid", L, N], V = () => ["auto", {
    span: ["full", Ge, L, N]
  }, Ge, L, N], Y = () => [Ge, "auto", L, N], B = () => ["auto", "min", "max", "fr", L, N], I = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], K = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], F = () => ["auto", ...E()], $ = () => [ut, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...E()], P = () => [e, L, N], X = () => [...S(), Wn, $n, {
    position: [L, N]
  }], ne = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], ie = () => ["auto", "cover", "contain", Vs, Ws, {
    size: [L, N]
  }], ke = () => [Pr, Et, ot], q = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    u,
    L,
    N
  ], J = () => ["", M, Et, ot], Ce = () => ["solid", "dashed", "dotted", "double"], de = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], H = () => [M, Pr, Wn, $n], pe = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    b,
    L,
    N
  ], ge = () => ["none", M, L, N], ae = () => ["none", M, L, N], le = () => [M, L, N], he = () => [ut, "full", ...E()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Ve],
      breakpoint: [Ve],
      color: [Ds],
      container: [Ve],
      "drop-shadow": [Ve],
      ease: ["in", "out", "in-out"],
      font: [$s],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Ve],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Ve],
      shadow: [Ve],
      spacing: ["px", M],
      text: [Ve],
      "text-shadow": [Ve],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", ut, N, L, w]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [M, N, L, s]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": C()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": C()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: O()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: T()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": T()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": T()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: k()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": k()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": k()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: _()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": _()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": _()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: _()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: _()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: _()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: _()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: _()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: _()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Ge, "auto", L, N]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [ut, "full", "auto", s, ...E()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [M, ut, "auto", "initial", "none", N]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", M, L, N]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", M, L, N]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Ge, "first", "last", "none", L, N]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": j()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: V()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": Y()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": Y()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": j()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: V()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": Y()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": Y()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": B()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": B()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: E()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": E()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": E()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...I(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...K(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...K()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...I()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...K(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...K(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": I()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...K(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...K()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: E()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: E()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: E()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: E()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: E()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: E()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: E()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: E()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: E()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: F()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: F()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: F()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: F()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: F()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: F()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: F()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: F()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: F()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": E()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": E()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: $()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [s, "screen", ...$()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          s,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...$()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          s,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [a]
          },
          ...$()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...$()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...$()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...$()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", r, Et, ot]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [n, L, Er]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Pr, N]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Bs, N, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [o, L, N]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [M, "none", L, Er]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          i,
          ...E()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", L, N]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", L, N]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: P()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: P()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Ce(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [M, "from-font", "auto", L, ot]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: P()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [M, "auto", L, N]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: E()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", L, N]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", L, N]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: X()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ne()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ie()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Ge, L, N],
          radial: ["", L, N],
          conic: [Ge, L, N]
        }, Hs, zs]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: P()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: ke()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: ke()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: ke()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: P()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: P()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: P()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: q()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": q()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": q()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": q()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": q()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": q()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": q()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": q()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": q()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": q()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": q()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": q()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": q()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": q()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": q()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: J()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": J()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": J()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": J()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": J()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": J()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": J()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": J()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": J()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": J()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": J()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Ce(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...Ce(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: P()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": P()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": P()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": P()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": P()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": P()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": P()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": P()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": P()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: P()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...Ce(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [M, L, N]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", M, Et, ot]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: P()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          c,
          $t,
          Ft
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: P()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", f, $t, Ft]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": P()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: J()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: P()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [M, ot]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": P()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": J()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": P()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", d, $t, Ft]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": P()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [M, L, N]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...de(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": de()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [M]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": H()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": H()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": P()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": P()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": H()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": H()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": P()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": P()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": H()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": H()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": P()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": P()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": H()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": H()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": P()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": P()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": H()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": H()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": P()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": P()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": H()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": H()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": P()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": P()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": H()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": H()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": P()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": P()
      }],
      "mask-image-radial": [{
        "mask-radial": [L, N]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": H()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": H()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": P()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": P()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": S()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [M]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": H()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": H()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": P()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": P()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: X()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: ne()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: ie()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", L, N]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          L,
          N
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: pe()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [M, L, N]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [M, L, N]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          g,
          $t,
          Ft
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": P()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", M, L, N]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [M, L, N]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", M, L, N]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [M, L, N]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", M, L, N]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          L,
          N
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": pe()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [M, L, N]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [M, L, N]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", M, L, N]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [M, L, N]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", M, L, N]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [M, L, N]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [M, L, N]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", M, L, N]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": E()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": E()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": E()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", L, N]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [M, "initial", L, N]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", v, L, N]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [M, L, N]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", y, L, N]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [m, L, N]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": O()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: ge()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": ge()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": ge()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": ge()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: ae()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": ae()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": ae()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": ae()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: le()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": le()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": le()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [L, N, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: O()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: he()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": he()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": he()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": he()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: P()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: P()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", L, N]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": E()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": E()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": E()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": E()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": E()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": E()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": E()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": E()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": E()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": E()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": E()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": E()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": E()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": E()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": E()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": E()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": E()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": E()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", L, N]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...P()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [M, Et, ot, Er]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...P()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, Gs = /* @__PURE__ */ ks(Ks);
function ue(...e) {
  return Gs(Wo(e));
}
const Xs = p.forwardRef(
  ({ className: e, variant: t, size: r, asChild: n = !1, ...o }, i) => {
    const a = n ? ss : "button";
    return /* @__PURE__ */ x.jsx(
      a,
      {
        className: ue(gs({ variant: t, size: r, className: e })),
        ref: i,
        ...o
      }
    );
  }
);
Xs.displayName = "Button";
function Q(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), r === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Js(e, t) {
  const r = p.createContext(t), n = (i) => {
    const { children: a, ...s } = i, l = p.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ x.jsx(r.Provider, { value: l, children: a });
  };
  n.displayName = e + "Provider";
  function o(i) {
    const a = p.useContext(r);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [n, o];
}
function lr(e, t = []) {
  let r = [];
  function n(i, a) {
    const s = p.createContext(a), l = r.length;
    r = [...r, a];
    const u = (f) => {
      var v;
      const { scope: d, children: g, ...b } = f, m = ((v = d == null ? void 0 : d[e]) == null ? void 0 : v[l]) || s, w = p.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ x.jsx(m.Provider, { value: w, children: g });
    };
    u.displayName = i + "Provider";
    function c(f, d) {
      var m;
      const g = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[l]) || s, b = p.useContext(g);
      if (b) return b;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return [u, c];
  }
  const o = () => {
    const i = r.map((a) => p.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || i;
      return p.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return o.scopeName = e, [n, qs(o, ...t)];
}
function qs(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const a = n.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(i)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return p.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var Ue = globalThis != null && globalThis.document ? p.useLayoutEffect : () => {
}, Zs = p[" useId ".trim().toString()] || (() => {
}), Qs = 0;
function Gt(e) {
  const [t, r] = p.useState(Zs());
  return Ue(() => {
    r((n) => n ?? String(Qs++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var el = p[" useInsertionEffect ".trim().toString()] || Ue;
function qo({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  },
  caller: n
}) {
  const [o, i, a] = tl({
    defaultProp: t,
    onChange: r
  }), s = e !== void 0, l = s ? e : o;
  {
    const c = p.useRef(e !== void 0);
    p.useEffect(() => {
      const f = c.current;
      f !== s && console.warn(
        `${n} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), c.current = s;
    }, [s, n]);
  }
  const u = p.useCallback(
    (c) => {
      var f;
      if (s) {
        const d = rl(c) ? c(e) : c;
        d !== e && ((f = a.current) == null || f.call(a, d));
      } else
        i(c);
    },
    [s, e, i, a]
  );
  return [l, u];
}
function tl({
  defaultProp: e,
  onChange: t
}) {
  const [r, n] = p.useState(e), o = p.useRef(r), i = p.useRef(t);
  return el(() => {
    i.current = t;
  }, [t]), p.useEffect(() => {
    var a;
    o.current !== r && ((a = i.current) == null || a.call(i, r), o.current = r);
  }, [r, o]), [r, n, i];
}
function rl(e) {
  return typeof e == "function";
}
var nl = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], re = nl.reduce((e, t) => {
  const r = /* @__PURE__ */ Jr(`Primitive.${t}`), n = p.forwardRef((o, i) => {
    const { asChild: a, ...s } = o, l = a ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ x.jsx(l, { ...s, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function ol(e, t) {
  e && Io.flushSync(() => e.dispatchEvent(t));
}
function be(e) {
  const t = p.useRef(e);
  return p.useEffect(() => {
    t.current = e;
  }), p.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function il(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = be(e);
  p.useEffect(() => {
    const n = (o) => {
      o.key === "Escape" && r(o);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var al = "DismissableLayer", Br = "dismissableLayer.update", sl = "dismissableLayer.pointerDownOutside", ll = "dismissableLayer.focusOutside", zn, Zo = p.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Zr = p.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, u = p.useContext(Zo), [c, f] = p.useState(null), d = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, g] = p.useState({}), b = oe(t, (k) => f(k)), m = Array.from(u.layers), [w] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), v = m.indexOf(w), y = c ? m.indexOf(c) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, S = y >= v, O = fl((k) => {
      const E = k.target, _ = [...u.branches].some((j) => j.contains(E));
      !S || _ || (o == null || o(k), a == null || a(k), k.defaultPrevented || s == null || s());
    }, d), T = dl((k) => {
      const E = k.target;
      [...u.branches].some((j) => j.contains(E)) || (i == null || i(k), a == null || a(k), k.defaultPrevented || s == null || s());
    }, d);
    return il((k) => {
      y === u.layers.size - 1 && (n == null || n(k), !k.defaultPrevented && s && (k.preventDefault(), s()));
    }, d), p.useEffect(() => {
      if (c)
        return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (zn = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), Bn(), () => {
          r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = zn);
        };
    }, [c, d, r, u]), p.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), Bn());
    }, [c, u]), p.useEffect(() => {
      const k = () => g({});
      return document.addEventListener(Br, k), () => document.removeEventListener(Br, k);
    }, []), /* @__PURE__ */ x.jsx(
      re.div,
      {
        ...l,
        ref: b,
        style: {
          pointerEvents: C ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Q(e.onFocusCapture, T.onFocusCapture),
        onBlurCapture: Q(e.onBlurCapture, T.onBlurCapture),
        onPointerDownCapture: Q(
          e.onPointerDownCapture,
          O.onPointerDownCapture
        )
      }
    );
  }
);
Zr.displayName = al;
var cl = "DismissableLayerBranch", ul = p.forwardRef((e, t) => {
  const r = p.useContext(Zo), n = p.useRef(null), o = oe(t, n);
  return p.useEffect(() => {
    const i = n.current;
    if (i)
      return r.branches.add(i), () => {
        r.branches.delete(i);
      };
  }, [r.branches]), /* @__PURE__ */ x.jsx(re.div, { ...e, ref: o });
});
ul.displayName = cl;
function fl(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = be(e), n = p.useRef(!1), o = p.useRef(() => {
  });
  return p.useEffect(() => {
    const i = (s) => {
      if (s.target && !n.current) {
        let l = function() {
          Qo(
            sl,
            r,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      n.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function dl(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = be(e), n = p.useRef(!1);
  return p.useEffect(() => {
    const o = (i) => {
      i.target && !n.current && Qo(ll, r, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Bn() {
  const e = new CustomEvent(Br);
  document.dispatchEvent(e);
}
function Qo(e, t, r, { discrete: n }) {
  const o = r.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? ol(o, i) : o.dispatchEvent(i);
}
var kr = "focusScope.autoFocusOnMount", Ar = "focusScope.autoFocusOnUnmount", Vn = { bubbles: !1, cancelable: !0 }, pl = "FocusScope", ei = p.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...a
  } = e, [s, l] = p.useState(null), u = be(o), c = be(i), f = p.useRef(null), d = oe(t, (m) => l(m)), g = p.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  p.useEffect(() => {
    if (n) {
      let m = function(C) {
        if (g.paused || !s) return;
        const S = C.target;
        s.contains(S) ? f.current = S : Xe(f.current, { select: !0 });
      }, w = function(C) {
        if (g.paused || !s) return;
        const S = C.relatedTarget;
        S !== null && (s.contains(S) || Xe(f.current, { select: !0 }));
      }, v = function(C) {
        if (document.activeElement === document.body)
          for (const O of C)
            O.removedNodes.length > 0 && Xe(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", w);
      const y = new MutationObserver(v);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", w), y.disconnect();
      };
    }
  }, [n, s, g.paused]), p.useEffect(() => {
    if (s) {
      Un.add(g);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const v = new CustomEvent(kr, Vn);
        s.addEventListener(kr, u), s.dispatchEvent(v), v.defaultPrevented || (gl(yl(ti(s)), { select: !0 }), document.activeElement === m && Xe(s));
      }
      return () => {
        s.removeEventListener(kr, u), setTimeout(() => {
          const v = new CustomEvent(Ar, Vn);
          s.addEventListener(Ar, c), s.dispatchEvent(v), v.defaultPrevented || Xe(m ?? document.body, { select: !0 }), s.removeEventListener(Ar, c), Un.remove(g);
        }, 0);
      };
    }
  }, [s, u, c, g]);
  const b = p.useCallback(
    (m) => {
      if (!r && !n || g.paused) return;
      const w = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, v = document.activeElement;
      if (w && v) {
        const y = m.currentTarget, [C, S] = hl(y);
        C && S ? !m.shiftKey && v === S ? (m.preventDefault(), r && Xe(C, { select: !0 })) : m.shiftKey && v === C && (m.preventDefault(), r && Xe(S, { select: !0 })) : v === y && m.preventDefault();
      }
    },
    [r, n, g.paused]
  );
  return /* @__PURE__ */ x.jsx(re.div, { tabIndex: -1, ...a, ref: d, onKeyDown: b });
});
ei.displayName = pl;
function gl(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (Xe(n, { select: t }), document.activeElement !== r) return;
}
function hl(e) {
  const t = ti(e), r = Hn(t, e), n = Hn(t.reverse(), e);
  return [r, n];
}
function ti(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Hn(e, t) {
  for (const r of e)
    if (!ml(r, { upTo: t })) return r;
}
function ml(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function vl(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Xe(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && vl(e) && t && e.select();
  }
}
var Un = bl();
function bl() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = Yn(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = Yn(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function Yn(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function yl(e) {
  return e.filter((t) => t.tagName !== "A");
}
var wl = "Portal", Qr = p.forwardRef((e, t) => {
  var s;
  const { container: r, ...n } = e, [o, i] = p.useState(!1);
  Ue(() => i(!0), []);
  const a = r || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? ns.createPortal(/* @__PURE__ */ x.jsx(re.div, { ...n, ref: t }), a) : null;
});
Qr.displayName = wl;
function xl(e, t) {
  return p.useReducer((r, n) => t[r][n] ?? r, e);
}
var Me = (e) => {
  const { present: t, children: r } = e, n = Sl(t), o = typeof r == "function" ? r({ present: n.isPresent }) : p.Children.only(r), i = oe(n.ref, Cl(o));
  return typeof r == "function" || n.isPresent ? p.cloneElement(o, { ref: i }) : null;
};
Me.displayName = "Presence";
function Sl(e) {
  const [t, r] = p.useState(), n = p.useRef(null), o = p.useRef(e), i = p.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = xl(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return p.useEffect(() => {
    const u = Wt(n.current);
    i.current = s === "mounted" ? u : "none";
  }, [s]), Ue(() => {
    const u = n.current, c = o.current;
    if (c !== e) {
      const d = i.current, g = Wt(u);
      e ? l("MOUNT") : g === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && d !== g ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), Ue(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, f = (g) => {
        const m = Wt(n.current).includes(CSS.escape(g.animationName));
        if (g.target === t && m && (l("ANIMATION_END"), !o.current)) {
          const w = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = w);
          });
        }
      }, d = (g) => {
        g.target === t && (i.current = Wt(n.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: p.useCallback((u) => {
      n.current = u ? getComputedStyle(u) : null, r(u);
    }, [])
  };
}
function Wt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Cl(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Tr = 0;
function Rl() {
  p.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Kn()), document.body.insertAdjacentElement("beforeend", e[1] ?? Kn()), Tr++, () => {
      Tr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Tr--;
    };
  }, []);
}
function Kn() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ne = function() {
  return Ne = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Ne.apply(this, arguments);
};
function ri(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function Ol(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, o = t.length, i; n < o; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Xt = "right-scroll-bar-position", Jt = "width-before-scroll-bar", Pl = "with-scroll-bars-hidden", El = "--removed-body-scroll-bar-size";
function Nr(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function kl(e, t) {
  var r = jo(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var o = r.value;
          o !== n && (r.value = n, r.callback(n, o));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var Al = typeof window < "u" ? p.useLayoutEffect : p.useEffect, Gn = /* @__PURE__ */ new WeakMap();
function Tl(e, t) {
  var r = kl(null, function(n) {
    return e.forEach(function(o) {
      return Nr(o, n);
    });
  });
  return Al(function() {
    var n = Gn.get(r);
    if (n) {
      var o = new Set(n), i = new Set(e), a = r.current;
      o.forEach(function(s) {
        i.has(s) || Nr(s, null);
      }), i.forEach(function(s) {
        o.has(s) || Nr(s, a);
      });
    }
    Gn.set(r, e);
  }, [e]), r;
}
function Nl(e) {
  return e;
}
function Ll(e, t) {
  t === void 0 && (t = Nl);
  var r = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, n);
      return r.push(a), function() {
        r = r.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; r.length; ) {
        var a = r;
        r = [], a.forEach(i);
      }
      r = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var a = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(i), a = r;
      }
      var l = function() {
        var c = a;
        a = [], c.forEach(i);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), r = {
        push: function(c) {
          a.push(c), u();
        },
        filter: function(c) {
          return a = a.filter(c), r;
        }
      };
    }
  };
  return o;
}
function _l(e) {
  e === void 0 && (e = {});
  var t = Ll(null);
  return t.options = Ne({ async: !0, ssr: !1 }, e), t;
}
var ni = function(e) {
  var t = e.sideCar, r = ri(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return p.createElement(n, Ne({}, r));
};
ni.isSideCarExport = !0;
function jl(e, t) {
  return e.useMedium(t), ni;
}
var oi = _l(), Lr = function() {
}, cr = p.forwardRef(function(e, t) {
  var r = p.useRef(null), n = p.useState({
    onScrollCapture: Lr,
    onWheelCapture: Lr,
    onTouchMoveCapture: Lr
  }), o = n[0], i = n[1], a = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, c = e.enabled, f = e.shards, d = e.sideCar, g = e.noRelative, b = e.noIsolation, m = e.inert, w = e.allowPinchZoom, v = e.as, y = v === void 0 ? "div" : v, C = e.gapMode, S = ri(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), O = d, T = Tl([r, t]), k = Ne(Ne({}, S), o);
  return p.createElement(
    p.Fragment,
    null,
    c && p.createElement(O, { sideCar: oi, removeScrollBar: u, shards: f, noRelative: g, noIsolation: b, inert: m, setCallbacks: i, allowPinchZoom: !!w, lockRef: r, gapMode: C }),
    a ? p.cloneElement(p.Children.only(s), Ne(Ne({}, k), { ref: T })) : p.createElement(y, Ne({}, k, { className: l, ref: T }), s)
  );
});
cr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
cr.classNames = {
  fullWidth: Jt,
  zeroRight: Xt
};
var Dl = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Il() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Dl();
  return t && e.setAttribute("nonce", t), e;
}
function Ml(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Fl(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var $l = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = Il()) && (Ml(t, r), Fl(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Wl = function() {
  var e = $l();
  return function(t, r) {
    p.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, ii = function() {
  var e = Wl(), t = function(r) {
    var n = r.styles, o = r.dynamic;
    return e(n, o), null;
  };
  return t;
}, zl = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, _r = function(e) {
  return parseInt(e || "", 10) || 0;
}, Bl = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [_r(r), _r(n), _r(o)];
}, Vl = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return zl;
  var t = Bl(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, Hl = ii(), mt = "data-scroll-locked", Ul = function(e, t, r, n) {
  var o = e.left, i = e.top, a = e.right, s = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(Pl, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body[`).concat(mt, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Xt, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Jt, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Xt, " .").concat(Xt, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Jt, " .").concat(Jt, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(mt, `] {
    `).concat(El, ": ").concat(s, `px;
  }
`);
}, Xn = function() {
  var e = parseInt(document.body.getAttribute(mt) || "0", 10);
  return isFinite(e) ? e : 0;
}, Yl = function() {
  p.useEffect(function() {
    return document.body.setAttribute(mt, (Xn() + 1).toString()), function() {
      var e = Xn() - 1;
      e <= 0 ? document.body.removeAttribute(mt) : document.body.setAttribute(mt, e.toString());
    };
  }, []);
}, Kl = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n;
  Yl();
  var i = p.useMemo(function() {
    return Vl(o);
  }, [o]);
  return p.createElement(Hl, { styles: Ul(i, !t, o, r ? "" : "!important") });
}, Vr = !1;
if (typeof window < "u")
  try {
    var zt = Object.defineProperty({}, "passive", {
      get: function() {
        return Vr = !0, !0;
      }
    });
    window.addEventListener("test", zt, zt), window.removeEventListener("test", zt, zt);
  } catch {
    Vr = !1;
  }
var ft = Vr ? { passive: !1 } : !1, Gl = function(e) {
  return e.tagName === "TEXTAREA";
}, ai = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !Gl(e) && r[t] === "visible")
  );
}, Xl = function(e) {
  return ai(e, "overflowY");
}, Jl = function(e) {
  return ai(e, "overflowX");
}, Jn = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = si(e, n);
    if (o) {
      var i = li(e, n), a = i[1], s = i[2];
      if (a > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, ql = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, Zl = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, si = function(e, t) {
  return e === "v" ? Xl(t) : Jl(t);
}, li = function(e, t) {
  return e === "v" ? ql(t) : Zl(t);
}, Ql = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, ec = function(e, t, r, n, o) {
  var i = Ql(e, window.getComputedStyle(t).direction), a = i * n, s = r.target, l = t.contains(s), u = !1, c = a > 0, f = 0, d = 0;
  do {
    if (!s)
      break;
    var g = li(e, s), b = g[0], m = g[1], w = g[2], v = m - w - i * b;
    (b || v) && si(e, s) && (f += v, d += b);
    var y = s.parentNode;
    s = y && y.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? y.host : y;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (c && Math.abs(f) < 1 || !c && Math.abs(d) < 1) && (u = !0), u;
}, Bt = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, qn = function(e) {
  return [e.deltaX, e.deltaY];
}, Zn = function(e) {
  return e && "current" in e ? e.current : e;
}, tc = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, rc = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, nc = 0, dt = [];
function oc(e) {
  var t = p.useRef([]), r = p.useRef([0, 0]), n = p.useRef(), o = p.useState(nc++)[0], i = p.useState(ii)[0], a = p.useRef(e);
  p.useEffect(function() {
    a.current = e;
  }, [e]), p.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = Ol([e.lockRef.current], (e.shards || []).map(Zn), !0).filter(Boolean);
      return m.forEach(function(w) {
        return w.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function(w) {
          return w.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = p.useCallback(function(m, w) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !a.current.allowPinchZoom;
    var v = Bt(m), y = r.current, C = "deltaX" in m ? m.deltaX : y[0] - v[0], S = "deltaY" in m ? m.deltaY : y[1] - v[1], O, T = m.target, k = Math.abs(C) > Math.abs(S) ? "h" : "v";
    if ("touches" in m && k === "h" && T.type === "range")
      return !1;
    var E = Jn(k, T);
    if (!E)
      return !0;
    if (E ? O = k : (O = k === "v" ? "h" : "v", E = Jn(k, T)), !E)
      return !1;
    if (!n.current && "changedTouches" in m && (C || S) && (n.current = O), !O)
      return !0;
    var _ = n.current || O;
    return ec(_, w, m, _ === "h" ? C : S);
  }, []), l = p.useCallback(function(m) {
    var w = m;
    if (!(!dt.length || dt[dt.length - 1] !== i)) {
      var v = "deltaY" in w ? qn(w) : Bt(w), y = t.current.filter(function(O) {
        return O.name === w.type && (O.target === w.target || w.target === O.shadowParent) && tc(O.delta, v);
      })[0];
      if (y && y.should) {
        w.cancelable && w.preventDefault();
        return;
      }
      if (!y) {
        var C = (a.current.shards || []).map(Zn).filter(Boolean).filter(function(O) {
          return O.contains(w.target);
        }), S = C.length > 0 ? s(w, C[0]) : !a.current.noIsolation;
        S && w.cancelable && w.preventDefault();
      }
    }
  }, []), u = p.useCallback(function(m, w, v, y) {
    var C = { name: m, delta: w, target: v, should: y, shadowParent: ic(v) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== C;
      });
    }, 1);
  }, []), c = p.useCallback(function(m) {
    r.current = Bt(m), n.current = void 0;
  }, []), f = p.useCallback(function(m) {
    u(m.type, qn(m), m.target, s(m, e.lockRef.current));
  }, []), d = p.useCallback(function(m) {
    u(m.type, Bt(m), m.target, s(m, e.lockRef.current));
  }, []);
  p.useEffect(function() {
    return dt.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", l, ft), document.addEventListener("touchmove", l, ft), document.addEventListener("touchstart", c, ft), function() {
      dt = dt.filter(function(m) {
        return m !== i;
      }), document.removeEventListener("wheel", l, ft), document.removeEventListener("touchmove", l, ft), document.removeEventListener("touchstart", c, ft);
    };
  }, []);
  var g = e.removeScrollBar, b = e.inert;
  return p.createElement(
    p.Fragment,
    null,
    b ? p.createElement(i, { styles: rc(o) }) : null,
    g ? p.createElement(Kl, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function ic(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const ac = jl(oi, oc);
var ci = p.forwardRef(function(e, t) {
  return p.createElement(cr, Ne({}, e, { ref: t, sideCar: ac }));
});
ci.classNames = cr.classNames;
var sc = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, pt = /* @__PURE__ */ new WeakMap(), Vt = /* @__PURE__ */ new WeakMap(), Ht = {}, jr = 0, ui = function(e) {
  return e && (e.host || ui(e.parentNode));
}, lc = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = ui(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, cc = function(e, t, r, n) {
  var o = lc(t, Array.isArray(e) ? e : [e]);
  Ht[r] || (Ht[r] = /* @__PURE__ */ new WeakMap());
  var i = Ht[r], a = [], s = /* @__PURE__ */ new Set(), l = new Set(o), u = function(f) {
    !f || s.has(f) || (s.add(f), u(f.parentNode));
  };
  o.forEach(u);
  var c = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(d) {
      if (s.has(d))
        c(d);
      else
        try {
          var g = d.getAttribute(n), b = g !== null && g !== "false", m = (pt.get(d) || 0) + 1, w = (i.get(d) || 0) + 1;
          pt.set(d, m), i.set(d, w), a.push(d), m === 1 && b && Vt.set(d, !0), w === 1 && d.setAttribute(r, "true"), b || d.setAttribute(n, "true");
        } catch (v) {
          console.error("aria-hidden: cannot operate on ", d, v);
        }
    });
  };
  return c(t), s.clear(), jr++, function() {
    a.forEach(function(f) {
      var d = pt.get(f) - 1, g = i.get(f) - 1;
      pt.set(f, d), i.set(f, g), d || (Vt.has(f) || f.removeAttribute(n), Vt.delete(f)), g || f.removeAttribute(r);
    }), jr--, jr || (pt = /* @__PURE__ */ new WeakMap(), pt = /* @__PURE__ */ new WeakMap(), Vt = /* @__PURE__ */ new WeakMap(), Ht = {});
  };
}, uc = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), o = sc(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live], script"))), cc(n, o, r, "aria-hidden")) : function() {
    return null;
  };
}, ur = "Dialog", [fi, $d] = lr(ur), [fc, Ee] = fi(ur), di = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: i,
    modal: a = !0
  } = e, s = p.useRef(null), l = p.useRef(null), [u, c] = qo({
    prop: n,
    defaultProp: o ?? !1,
    onChange: i,
    caller: ur
  });
  return /* @__PURE__ */ x.jsx(
    fc,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: Gt(),
      titleId: Gt(),
      descriptionId: Gt(),
      open: u,
      onOpenChange: c,
      onOpenToggle: p.useCallback(() => c((f) => !f), [c]),
      modal: a,
      children: r
    }
  );
};
di.displayName = ur;
var pi = "DialogTrigger", gi = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Ee(pi, r), i = oe(t, o.triggerRef);
    return /* @__PURE__ */ x.jsx(
      re.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": rn(o.open),
        ...n,
        ref: i,
        onClick: Q(e.onClick, o.onOpenToggle)
      }
    );
  }
);
gi.displayName = pi;
var en = "DialogPortal", [dc, hi] = fi(en, {
  forceMount: void 0
}), mi = (e) => {
  const { __scopeDialog: t, forceMount: r, children: n, container: o } = e, i = Ee(en, t);
  return /* @__PURE__ */ x.jsx(dc, { scope: t, forceMount: r, children: p.Children.map(n, (a) => /* @__PURE__ */ x.jsx(Me, { present: r || i.open, children: /* @__PURE__ */ x.jsx(Qr, { asChild: !0, container: o, children: a }) })) });
};
mi.displayName = en;
var Zt = "DialogOverlay", vi = p.forwardRef(
  (e, t) => {
    const r = hi(Zt, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, i = Ee(Zt, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ x.jsx(Me, { present: n || i.open, children: /* @__PURE__ */ x.jsx(gc, { ...o, ref: t }) }) : null;
  }
);
vi.displayName = Zt;
var pc = /* @__PURE__ */ Jr("DialogOverlay.RemoveScroll"), gc = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Ee(Zt, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ x.jsx(ci, { as: pc, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ x.jsx(
        re.div,
        {
          "data-state": rn(o.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), it = "DialogContent", bi = p.forwardRef(
  (e, t) => {
    const r = hi(it, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, i = Ee(it, e.__scopeDialog);
    return /* @__PURE__ */ x.jsx(Me, { present: n || i.open, children: i.modal ? /* @__PURE__ */ x.jsx(hc, { ...o, ref: t }) : /* @__PURE__ */ x.jsx(mc, { ...o, ref: t }) });
  }
);
bi.displayName = it;
var hc = p.forwardRef(
  (e, t) => {
    const r = Ee(it, e.__scopeDialog), n = p.useRef(null), o = oe(t, r.contentRef, n);
    return p.useEffect(() => {
      const i = n.current;
      if (i) return uc(i);
    }, []), /* @__PURE__ */ x.jsx(
      yi,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Q(e.onCloseAutoFocus, (i) => {
          var a;
          i.preventDefault(), (a = r.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: Q(e.onPointerDownOutside, (i) => {
          const a = i.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || s) && i.preventDefault();
        }),
        onFocusOutside: Q(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), mc = p.forwardRef(
  (e, t) => {
    const r = Ee(it, e.__scopeDialog), n = p.useRef(!1), o = p.useRef(!1);
    return /* @__PURE__ */ x.jsx(
      yi,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var a, s;
          (a = e.onCloseAutoFocus) == null || a.call(e, i), i.defaultPrevented || (n.current || (s = r.triggerRef.current) == null || s.focus(), i.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = i.target;
          ((u = r.triggerRef.current) == null ? void 0 : u.contains(a)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), yi = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: o, onCloseAutoFocus: i, ...a } = e, s = Ee(it, r), l = p.useRef(null), u = oe(t, l);
    return Rl(), /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        ei,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ x.jsx(
            Zr,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": rn(s.open),
              ...a,
              ref: u,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        /* @__PURE__ */ x.jsx(vc, { titleId: s.titleId }),
        /* @__PURE__ */ x.jsx(yc, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), tn = "DialogTitle", wi = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Ee(tn, r);
    return /* @__PURE__ */ x.jsx(re.h2, { id: o.titleId, ...n, ref: t });
  }
);
wi.displayName = tn;
var xi = "DialogDescription", Si = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Ee(xi, r);
    return /* @__PURE__ */ x.jsx(re.p, { id: o.descriptionId, ...n, ref: t });
  }
);
Si.displayName = xi;
var Ci = "DialogClose", Ri = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Ee(Ci, r);
    return /* @__PURE__ */ x.jsx(
      re.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: Q(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Ri.displayName = Ci;
function rn(e) {
  return e ? "open" : "closed";
}
var Oi = "DialogTitleWarning", [Wd, Pi] = Js(Oi, {
  contentName: it,
  titleName: tn,
  docsSlug: "dialog"
}), vc = ({ titleId: e }) => {
  const t = Pi(Oi), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return p.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, bc = "DialogDescriptionWarning", yc = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Pi(bc).contentName}}.`;
  return p.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, wc = di, xc = gi, Sc = mi, Ei = vi, ki = bi, Ai = wi, Ti = Si, Ni = Ri;
/**
 * @license lucide-react v0.536.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cc = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Rc = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, r, n) => n ? n.toUpperCase() : r.toLowerCase()
), Qn = (e) => {
  const t = Rc(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, Li = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim(), Oc = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.536.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Pc = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.536.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ec = Do(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: o = "",
    children: i,
    iconNode: a,
    ...s
  }, l) => Fr(
    "svg",
    {
      ref: l,
      ...Pc,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(t) : r,
      className: Li("lucide", o),
      ...!i && !Oc(s) && { "aria-hidden": "true" },
      ...s
    },
    [
      ...a.map(([u, c]) => Fr(u, c)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.536.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _i = (e, t) => {
  const r = Do(
    ({ className: n, ...o }, i) => Fr(Ec, {
      ref: i,
      iconNode: t,
      className: Li(
        `lucide-${Cc(Qn(e))}`,
        `lucide-${e}`,
        n
      ),
      ...o
    })
  );
  return r.displayName = Qn(e), r;
};
/**
 * @license lucide-react v0.536.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kc = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], Ac = _i("circle-question-mark", kc);
/**
 * @license lucide-react v0.536.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tc = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], Nc = _i("x", Tc);
var Lc = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), _c = "VisuallyHidden", nn = p.forwardRef(
  (e, t) => /* @__PURE__ */ x.jsx(
    re.span,
    {
      ...e,
      ref: t,
      style: { ...Lc, ...e.style }
    }
  )
);
nn.displayName = _c;
var jc = nn;
function xe(e) {
  "@babel/helpers - typeof";
  return xe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xe(e);
}
function Fe(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Dc(e, t) {
  if (xe(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (xe(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ji(e) {
  var t = Dc(e, "string");
  return xe(t) == "symbol" ? t : t + "";
}
function eo(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ji(n.key), n);
  }
}
function $e(e, t, r) {
  return t && eo(e.prototype, t), r && eo(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Je(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Hr(e, t) {
  return Hr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Hr(e, t);
}
function fr(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Hr(e, t);
}
function Lt(e, t) {
  if (t && (xe(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Je(e);
}
function De(e) {
  return De = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, De(e);
}
function et(e, t, r) {
  return (t = ji(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Ic(e) {
  if (Array.isArray(e)) return e;
}
function Mc(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function to(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Fc(e, t) {
  if (e) {
    if (typeof e == "string") return to(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? to(e, t) : void 0;
  }
}
function $c() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wc(e) {
  return Ic(e) || Mc(e) || Fc(e) || $c();
}
function ro(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function no(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ro(Object(r), !0).forEach(function(n) {
      et(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ro(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
var zc = {
  type: "logger",
  log: function(t) {
    this.output("log", t);
  },
  warn: function(t) {
    this.output("warn", t);
  },
  error: function(t) {
    this.output("error", t);
  },
  output: function(t, r) {
    console && console[t] && console[t].apply(console, r);
  }
}, Bc = (function() {
  function e(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Fe(this, e), this.init(t, r);
  }
  return $e(e, [{
    key: "init",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = n.prefix || "i18next:", this.logger = r || zc, this.options = n, this.debug = n.debug;
    }
  }, {
    key: "setDebug",
    value: function(r) {
      this.debug = r;
    }
  }, {
    key: "log",
    value: function() {
      for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++)
        n[o] = arguments[o];
      return this.forward(n, "log", "", !0);
    }
  }, {
    key: "warn",
    value: function() {
      for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++)
        n[o] = arguments[o];
      return this.forward(n, "warn", "", !0);
    }
  }, {
    key: "error",
    value: function() {
      for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++)
        n[o] = arguments[o];
      return this.forward(n, "error", "");
    }
  }, {
    key: "deprecate",
    value: function() {
      for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++)
        n[o] = arguments[o];
      return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
    }
  }, {
    key: "forward",
    value: function(r, n, o, i) {
      return i && !this.debug ? null : (typeof r[0] == "string" && (r[0] = "".concat(o).concat(this.prefix, " ").concat(r[0])), this.logger[n](r));
    }
  }, {
    key: "create",
    value: function(r) {
      return new e(this.logger, no(no({}, {
        prefix: "".concat(this.prefix, ":").concat(r, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function(r) {
      return r = r || this.options, r.prefix = r.prefix || this.prefix, new e(this.logger, r);
    }
  }]), e;
})(), Le = new Bc(), qe = (function() {
  function e() {
    Fe(this, e), this.observers = {};
  }
  return $e(e, [{
    key: "on",
    value: function(r, n) {
      var o = this;
      return r.split(" ").forEach(function(i) {
        o.observers[i] = o.observers[i] || [], o.observers[i].push(n);
      }), this;
    }
  }, {
    key: "off",
    value: function(r, n) {
      if (this.observers[r]) {
        if (!n) {
          delete this.observers[r];
          return;
        }
        this.observers[r] = this.observers[r].filter(function(o) {
          return o !== n;
        });
      }
    }
  }, {
    key: "emit",
    value: function(r) {
      for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
        o[i - 1] = arguments[i];
      if (this.observers[r]) {
        var a = [].concat(this.observers[r]);
        a.forEach(function(l) {
          l.apply(void 0, o);
        });
      }
      if (this.observers["*"]) {
        var s = [].concat(this.observers["*"]);
        s.forEach(function(l) {
          l.apply(l, [r].concat(o));
        });
      }
    }
  }]), e;
})();
function kt() {
  var e, t, r = new Promise(function(n, o) {
    e = n, t = o;
  });
  return r.resolve = e, r.reject = t, r;
}
function oo(e) {
  return e == null ? "" : "" + e;
}
function Vc(e, t, r) {
  e.forEach(function(n) {
    t[n] && (r[n] = t[n]);
  });
}
function on(e, t, r) {
  function n(s) {
    return s && s.indexOf("###") > -1 ? s.replace(/###/g, ".") : s;
  }
  function o() {
    return !e || typeof e == "string";
  }
  for (var i = typeof t != "string" ? [].concat(t) : t.split("."); i.length > 1; ) {
    if (o()) return {};
    var a = n(i.shift());
    !e[a] && r && (e[a] = new r()), Object.prototype.hasOwnProperty.call(e, a) ? e = e[a] : e = {};
  }
  return o() ? {} : {
    obj: e,
    k: n(i.shift())
  };
}
function io(e, t, r) {
  var n = on(e, t, Object), o = n.obj, i = n.k;
  o[i] = r;
}
function Hc(e, t, r, n) {
  var o = on(e, t, Object), i = o.obj, a = o.k;
  i[a] = i[a] || [], i[a].push(r);
}
function Qt(e, t) {
  var r = on(e, t), n = r.obj, o = r.k;
  if (n)
    return n[o];
}
function Uc(e, t, r) {
  var n = Qt(e, r);
  return n !== void 0 ? n : Qt(t, r);
}
function Di(e, t, r) {
  for (var n in t)
    n !== "__proto__" && n !== "constructor" && (n in e ? typeof e[n] == "string" || e[n] instanceof String || typeof t[n] == "string" || t[n] instanceof String ? r && (e[n] = t[n]) : Di(e[n], t[n], r) : e[n] = t[n]);
  return e;
}
function gt(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var Yc = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function Kc(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, function(t) {
    return Yc[t];
  }) : e;
}
var dr = typeof window < "u" && window.navigator && typeof window.navigator.userAgentData > "u" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1, Gc = [" ", ",", "?", "!", ";"];
function Xc(e, t, r) {
  t = t || "", r = r || "";
  var n = Gc.filter(function(s) {
    return t.indexOf(s) < 0 && r.indexOf(s) < 0;
  });
  if (n.length === 0) return !0;
  var o = new RegExp("(".concat(n.map(function(s) {
    return s === "?" ? "\\?" : s;
  }).join("|"), ")")), i = !o.test(e);
  if (!i) {
    var a = e.indexOf(r);
    a > 0 && !o.test(e.substring(0, a)) && (i = !0);
  }
  return i;
}
function er(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (e) {
    if (e[t]) return e[t];
    for (var n = t.split(r), o = e, i = 0; i < n.length; ++i) {
      if (!o || typeof o[n[i]] == "string" && i + 1 < n.length)
        return;
      if (o[n[i]] === void 0) {
        for (var a = 2, s = n.slice(i, i + a).join(r), l = o[s]; l === void 0 && n.length > i + a; )
          a++, s = n.slice(i, i + a).join(r), l = o[s];
        if (l === void 0) return;
        if (l === null) return null;
        if (t.endsWith(s)) {
          if (typeof l == "string") return l;
          if (s && typeof l[s] == "string") return l[s];
        }
        var u = n.slice(i + a).join(r);
        return u ? er(l, u, r) : void 0;
      }
      o = o[n[i]];
    }
    return o;
  }
}
function ao(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ut(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ao(Object(r), !0).forEach(function(n) {
      et(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ao(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Jc(e) {
  var t = qc();
  return function() {
    var n = De(e), o;
    if (t) {
      var i = De(this).constructor;
      o = Reflect.construct(n, arguments, i);
    } else
      o = n.apply(this, arguments);
    return Lt(this, o);
  };
}
function qc() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var Zc = (function(e) {
  fr(r, e);
  var t = Jc(r);
  function r(n) {
    var o, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    return Fe(this, r), o = t.call(this), dr && qe.call(Je(o)), o.data = n || {}, o.options = i, o.options.keySeparator === void 0 && (o.options.keySeparator = "."), o.options.ignoreJSONStructure === void 0 && (o.options.ignoreJSONStructure = !0), o;
  }
  return $e(r, [{
    key: "addNamespaces",
    value: function(o) {
      this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
    }
  }, {
    key: "removeNamespaces",
    value: function(o) {
      var i = this.options.ns.indexOf(o);
      i > -1 && this.options.ns.splice(i, 1);
    }
  }, {
    key: "getResource",
    value: function(o, i, a) {
      var s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, l = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, u = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure, c = [o, i];
      a && typeof a != "string" && (c = c.concat(a)), a && typeof a == "string" && (c = c.concat(l ? a.split(l) : a)), o.indexOf(".") > -1 && (c = o.split("."));
      var f = Qt(this.data, c);
      return f || !u || typeof a != "string" ? f : er(this.data && this.data[o] && this.data[o][i], a, l);
    }
  }, {
    key: "addResource",
    value: function(o, i, a, s) {
      var l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: !1
      }, u = l.keySeparator !== void 0 ? l.keySeparator : this.options.keySeparator, c = [o, i];
      a && (c = c.concat(u ? a.split(u) : a)), o.indexOf(".") > -1 && (c = o.split("."), s = i, i = c[1]), this.addNamespaces(i), io(this.data, c, s), l.silent || this.emit("added", o, i, a, s);
    }
  }, {
    key: "addResources",
    value: function(o, i, a) {
      var s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: !1
      };
      for (var l in a)
        (typeof a[l] == "string" || Object.prototype.toString.apply(a[l]) === "[object Array]") && this.addResource(o, i, l, a[l], {
          silent: !0
        });
      s.silent || this.emit("added", o, i, a);
    }
  }, {
    key: "addResourceBundle",
    value: function(o, i, a, s, l) {
      var u = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: !1
      }, c = [o, i];
      o.indexOf(".") > -1 && (c = o.split("."), s = a, a = i, i = c[1]), this.addNamespaces(i);
      var f = Qt(this.data, c) || {};
      s ? Di(f, a, l) : f = Ut(Ut({}, f), a), io(this.data, c, f), u.silent || this.emit("added", o, i, a);
    }
  }, {
    key: "removeResourceBundle",
    value: function(o, i) {
      this.hasResourceBundle(o, i) && delete this.data[o][i], this.removeNamespaces(i), this.emit("removed", o, i);
    }
  }, {
    key: "hasResourceBundle",
    value: function(o, i) {
      return this.getResource(o, i) !== void 0;
    }
  }, {
    key: "getResourceBundle",
    value: function(o, i) {
      return i || (i = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? Ut(Ut({}, {}), this.getResource(o, i)) : this.getResource(o, i);
    }
  }, {
    key: "getDataByLanguage",
    value: function(o) {
      return this.data[o];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function(o) {
      var i = this.getDataByLanguage(o), a = i && Object.keys(i) || [];
      return !!a.find(function(s) {
        return i[s] && Object.keys(i[s]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      return this.data;
    }
  }]), r;
})(qe), Ii = {
  processors: {},
  addPostProcessor: function(t) {
    this.processors[t.name] = t;
  },
  handle: function(t, r, n, o, i) {
    var a = this;
    return t.forEach(function(s) {
      a.processors[s] && (r = a.processors[s].process(r, n, o, i));
    }), r;
  }
};
function so(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function se(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? so(Object(r), !0).forEach(function(n) {
      et(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : so(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Qc(e) {
  var t = eu();
  return function() {
    var n = De(e), o;
    if (t) {
      var i = De(this).constructor;
      o = Reflect.construct(n, arguments, i);
    } else
      o = n.apply(this, arguments);
    return Lt(this, o);
  };
}
function eu() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var lo = {}, co = (function(e) {
  fr(r, e);
  var t = Qc(r);
  function r(n) {
    var o, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Fe(this, r), o = t.call(this), dr && qe.call(Je(o)), Vc(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], n, Je(o)), o.options = i, o.options.keySeparator === void 0 && (o.options.keySeparator = "."), o.logger = Le.create("translator"), o;
  }
  return $e(r, [{
    key: "changeLanguage",
    value: function(o) {
      o && (this.language = o);
    }
  }, {
    key: "exists",
    value: function(o) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      if (o == null)
        return !1;
      var a = this.resolve(o, i);
      return a && a.res !== void 0;
    }
  }, {
    key: "extractFromKey",
    value: function(o, i) {
      var a = i.nsSeparator !== void 0 ? i.nsSeparator : this.options.nsSeparator;
      a === void 0 && (a = ":");
      var s = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator, l = i.ns || this.options.defaultNS || [], u = a && o.indexOf(a) > -1, c = !this.options.userDefinedKeySeparator && !i.keySeparator && !this.options.userDefinedNsSeparator && !i.nsSeparator && !Xc(o, a, s);
      if (u && !c) {
        var f = o.match(this.interpolator.nestingRegexp);
        if (f && f.length > 0)
          return {
            key: o,
            namespaces: l
          };
        var d = o.split(a);
        (a !== s || a === s && this.options.ns.indexOf(d[0]) > -1) && (l = d.shift()), o = d.join(s);
      }
      return typeof l == "string" && (l = [l]), {
        key: o,
        namespaces: l
      };
    }
  }, {
    key: "translate",
    value: function(o, i, a) {
      var s = this;
      if (xe(i) !== "object" && this.options.overloadTranslationOptionHandler && (i = this.options.overloadTranslationOptionHandler(arguments)), xe(i) === "object" && (i = se({}, i)), i || (i = {}), o == null) return "";
      Array.isArray(o) || (o = [String(o)]);
      var l = i.returnDetails !== void 0 ? i.returnDetails : this.options.returnDetails, u = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator, c = this.extractFromKey(o[o.length - 1], i), f = c.key, d = c.namespaces, g = d[d.length - 1], b = i.lng || this.language, m = i.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (b && b.toLowerCase() === "cimode") {
        if (m) {
          var w = i.nsSeparator || this.options.nsSeparator;
          return l ? {
            res: "".concat(g).concat(w).concat(f),
            usedKey: f,
            exactUsedKey: f,
            usedLng: b,
            usedNS: g
          } : "".concat(g).concat(w).concat(f);
        }
        return l ? {
          res: f,
          usedKey: f,
          exactUsedKey: f,
          usedLng: b,
          usedNS: g
        } : f;
      }
      var v = this.resolve(o, i), y = v && v.res, C = v && v.usedKey || f, S = v && v.exactUsedKey || f, O = Object.prototype.toString.apply(y), T = ["[object Number]", "[object Function]", "[object RegExp]"], k = i.joinArrays !== void 0 ? i.joinArrays : this.options.joinArrays, E = !this.i18nFormat || this.i18nFormat.handleAsObject, _ = typeof y != "string" && typeof y != "boolean" && typeof y != "number";
      if (E && y && _ && T.indexOf(O) < 0 && !(typeof k == "string" && O === "[object Array]")) {
        if (!i.returnObjects && !this.options.returnObjects) {
          this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
          var j = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(C, y, se(se({}, i), {}, {
            ns: d
          })) : "key '".concat(f, " (").concat(this.language, ")' returned an object instead of string.");
          return l ? (v.res = j, v) : j;
        }
        if (u) {
          var V = O === "[object Array]", Y = V ? [] : {}, B = V ? S : C;
          for (var I in y)
            if (Object.prototype.hasOwnProperty.call(y, I)) {
              var K = "".concat(B).concat(u).concat(I);
              Y[I] = this.translate(K, se(se({}, i), {
                joinArrays: !1,
                ns: d
              })), Y[I] === K && (Y[I] = y[I]);
            }
          y = Y;
        }
      } else if (E && typeof k == "string" && O === "[object Array]")
        y = y.join(k), y && (y = this.extendTranslation(y, o, i, a));
      else {
        var F = !1, $ = !1, P = i.count !== void 0 && typeof i.count != "string", X = r.hasDefaultValue(i), ne = P ? this.pluralResolver.getSuffix(b, i.count, i) : "", ie = i["defaultValue".concat(ne)] || i.defaultValue;
        !this.isValidLookup(y) && X && (F = !0, y = ie), this.isValidLookup(y) || ($ = !0, y = f);
        var ke = i.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey, q = ke && $ ? void 0 : y, J = X && ie !== y && this.options.updateMissing;
        if ($ || F || J) {
          if (this.logger.log(J ? "updateKey" : "missingKey", b, g, f, J ? ie : y), u) {
            var Ce = this.resolve(f, se(se({}, i), {}, {
              keySeparator: !1
            }));
            Ce && Ce.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          var de = [], H = this.languageUtils.getFallbackCodes(this.options.fallbackLng, i.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && H && H[0])
            for (var pe = 0; pe < H.length; pe++)
              de.push(H[pe]);
          else this.options.saveMissingTo === "all" ? de = this.languageUtils.toResolveHierarchy(i.lng || this.language) : de.push(i.lng || this.language);
          var ge = function(le, he, Ae) {
            var tt = X && Ae !== y ? Ae : q;
            s.options.missingKeyHandler ? s.options.missingKeyHandler(le, g, he, tt, J, i) : s.backendConnector && s.backendConnector.saveMissing && s.backendConnector.saveMissing(le, g, he, tt, J, i), s.emit("missingKey", le, g, he, y);
          };
          this.options.saveMissing && (this.options.saveMissingPlurals && P ? de.forEach(function(ae) {
            s.pluralResolver.getSuffixes(ae, i).forEach(function(le) {
              ge([ae], f + le, i["defaultValue".concat(le)] || ie);
            });
          }) : ge(de, f, ie));
        }
        y = this.extendTranslation(y, o, i, v, a), $ && y === f && this.options.appendNamespaceToMissingKey && (y = "".concat(g, ":").concat(f)), ($ || F) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? y = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(g, ":").concat(f) : f, F ? y : void 0) : y = this.options.parseMissingKeyHandler(y));
      }
      return l ? (v.res = y, v) : y;
    }
  }, {
    key: "extendTranslation",
    value: function(o, i, a, s, l) {
      var u = this;
      if (this.i18nFormat && this.i18nFormat.parse)
        o = this.i18nFormat.parse(o, se(se({}, this.options.interpolation.defaultVariables), a), s.usedLng, s.usedNS, s.usedKey, {
          resolved: s
        });
      else if (!a.skipInterpolation) {
        a.interpolation && this.interpolator.init(se(se({}, a), {
          interpolation: se(se({}, this.options.interpolation), a.interpolation)
        }));
        var c = typeof o == "string" && (a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables), f;
        if (c) {
          var d = o.match(this.interpolator.nestingRegexp);
          f = d && d.length;
        }
        var g = a.replace && typeof a.replace != "string" ? a.replace : a;
        if (this.options.interpolation.defaultVariables && (g = se(se({}, this.options.interpolation.defaultVariables), g)), o = this.interpolator.interpolate(o, g, a.lng || this.language, a), c) {
          var b = o.match(this.interpolator.nestingRegexp), m = b && b.length;
          f < m && (a.nest = !1);
        }
        !a.lng && this.options.compatibilityAPI !== "v1" && s && s.res && (a.lng = s.usedLng), a.nest !== !1 && (o = this.interpolator.nest(o, function() {
          for (var y = arguments.length, C = new Array(y), S = 0; S < y; S++)
            C[S] = arguments[S];
          return l && l[0] === C[0] && !a.context ? (u.logger.warn("It seems you are nesting recursively key: ".concat(C[0], " in key: ").concat(i[0])), null) : u.translate.apply(u, C.concat([i]));
        }, a)), a.interpolation && this.interpolator.reset();
      }
      var w = a.postProcess || this.options.postProcess, v = typeof w == "string" ? [w] : w;
      return o != null && v && v.length && a.applyPostProcessor !== !1 && (o = Ii.handle(v, o, i, this.options && this.options.postProcessPassResolved ? se({
        i18nResolved: s
      }, a) : a, this)), o;
    }
  }, {
    key: "resolve",
    value: function(o) {
      var i = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s, l, u, c, f;
      return typeof o == "string" && (o = [o]), o.forEach(function(d) {
        if (!i.isValidLookup(s)) {
          var g = i.extractFromKey(d, a), b = g.key;
          l = b;
          var m = g.namespaces;
          i.options.fallbackNS && (m = m.concat(i.options.fallbackNS));
          var w = a.count !== void 0 && typeof a.count != "string", v = w && !a.ordinal && a.count === 0 && i.pluralResolver.shouldUseIntlApi(), y = a.context !== void 0 && (typeof a.context == "string" || typeof a.context == "number") && a.context !== "", C = a.lngs ? a.lngs : i.languageUtils.toResolveHierarchy(a.lng || i.language, a.fallbackLng);
          m.forEach(function(S) {
            i.isValidLookup(s) || (f = S, !lo["".concat(C[0], "-").concat(S)] && i.utils && i.utils.hasLoadedNamespace && !i.utils.hasLoadedNamespace(f) && (lo["".concat(C[0], "-").concat(S)] = !0, i.logger.warn('key "'.concat(l, '" for languages "').concat(C.join(", "), `" won't get resolved as namespace "`).concat(f, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), C.forEach(function(O) {
              if (!i.isValidLookup(s)) {
                c = O;
                var T = [b];
                if (i.i18nFormat && i.i18nFormat.addLookupKeys)
                  i.i18nFormat.addLookupKeys(T, b, O, S, a);
                else {
                  var k;
                  w && (k = i.pluralResolver.getSuffix(O, a.count, a));
                  var E = "".concat(i.options.pluralSeparator, "zero");
                  if (w && (T.push(b + k), v && T.push(b + E)), y) {
                    var _ = "".concat(b).concat(i.options.contextSeparator).concat(a.context);
                    T.push(_), w && (T.push(_ + k), v && T.push(_ + E));
                  }
                }
                for (var j; j = T.pop(); )
                  i.isValidLookup(s) || (u = j, s = i.getResource(O, S, j, a));
              }
            }));
          });
        }
      }), {
        res: s,
        usedKey: l,
        exactUsedKey: u,
        usedLng: c,
        usedNS: f
      };
    }
  }, {
    key: "isValidLookup",
    value: function(o) {
      return o !== void 0 && !(!this.options.returnNull && o === null) && !(!this.options.returnEmptyString && o === "");
    }
  }, {
    key: "getResource",
    value: function(o, i, a) {
      var s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(o, i, a, s) : this.resourceStore.getResource(o, i, a, s);
    }
  }], [{
    key: "hasDefaultValue",
    value: function(o) {
      var i = "defaultValue";
      for (var a in o)
        if (Object.prototype.hasOwnProperty.call(o, a) && i === a.substring(0, i.length) && o[a] !== void 0)
          return !0;
      return !1;
    }
  }]), r;
})(qe);
function Dr(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var uo = (function() {
  function e(t) {
    Fe(this, e), this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Le.create("languageUtils");
  }
  return $e(e, [{
    key: "getScriptPartFromCode",
    value: function(r) {
      if (!r || r.indexOf("-") < 0) return null;
      var n = r.split("-");
      return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function(r) {
      if (!r || r.indexOf("-") < 0) return r;
      var n = r.split("-");
      return this.formatLanguageCode(n[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function(r) {
      if (typeof r == "string" && r.indexOf("-") > -1) {
        var n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"], o = r.split("-");
        return this.options.lowerCaseLng ? o = o.map(function(i) {
          return i.toLowerCase();
        }) : o.length === 2 ? (o[0] = o[0].toLowerCase(), o[1] = o[1].toUpperCase(), n.indexOf(o[1].toLowerCase()) > -1 && (o[1] = Dr(o[1].toLowerCase()))) : o.length === 3 && (o[0] = o[0].toLowerCase(), o[1].length === 2 && (o[1] = o[1].toUpperCase()), o[0] !== "sgn" && o[2].length === 2 && (o[2] = o[2].toUpperCase()), n.indexOf(o[1].toLowerCase()) > -1 && (o[1] = Dr(o[1].toLowerCase())), n.indexOf(o[2].toLowerCase()) > -1 && (o[2] = Dr(o[2].toLowerCase()))), o.join("-");
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? r.toLowerCase() : r;
    }
  }, {
    key: "isSupportedCode",
    value: function(r) {
      return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (r = this.getLanguagePartFromCode(r)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(r) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function(r) {
      var n = this;
      if (!r) return null;
      var o;
      return r.forEach(function(i) {
        if (!o) {
          var a = n.formatLanguageCode(i);
          (!n.options.supportedLngs || n.isSupportedCode(a)) && (o = a);
        }
      }), !o && this.options.supportedLngs && r.forEach(function(i) {
        if (!o) {
          var a = n.getLanguagePartFromCode(i);
          if (n.isSupportedCode(a)) return o = a;
          o = n.options.supportedLngs.find(function(s) {
            if (s === a) return s;
            if (!(s.indexOf("-") < 0 && a.indexOf("-") < 0) && s.indexOf(a) === 0)
              return s;
          });
        }
      }), o || (o = this.getFallbackCodes(this.options.fallbackLng)[0]), o;
    }
  }, {
    key: "getFallbackCodes",
    value: function(r, n) {
      if (!r) return [];
      if (typeof r == "function" && (r = r(n)), typeof r == "string" && (r = [r]), Object.prototype.toString.apply(r) === "[object Array]") return r;
      if (!n) return r.default || [];
      var o = r[n];
      return o || (o = r[this.getScriptPartFromCode(n)]), o || (o = r[this.formatLanguageCode(n)]), o || (o = r[this.getLanguagePartFromCode(n)]), o || (o = r.default), o || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function(r, n) {
      var o = this, i = this.getFallbackCodes(n || this.options.fallbackLng || [], r), a = [], s = function(u) {
        u && (o.isSupportedCode(u) ? a.push(u) : o.logger.warn("rejecting language code not found in supportedLngs: ".concat(u)));
      };
      return typeof r == "string" && r.indexOf("-") > -1 ? (this.options.load !== "languageOnly" && s(this.formatLanguageCode(r)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && s(this.getScriptPartFromCode(r)), this.options.load !== "currentOnly" && s(this.getLanguagePartFromCode(r))) : typeof r == "string" && s(this.formatLanguageCode(r)), i.forEach(function(l) {
        a.indexOf(l) < 0 && s(o.formatLanguageCode(l));
      }), a;
    }
  }]), e;
})(), tu = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], ru = {
  1: function(t) {
    return +(t > 1);
  },
  2: function(t) {
    return +(t != 1);
  },
  3: function(t) {
    return 0;
  },
  4: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  5: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5;
  },
  6: function(t) {
    return t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2;
  },
  7: function(t) {
    return t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  8: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3;
  },
  9: function(t) {
    return +(t >= 2);
  },
  10: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4;
  },
  11: function(t) {
    return t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3;
  },
  12: function(t) {
    return +(t % 10 != 1 || t % 100 == 11);
  },
  13: function(t) {
    return +(t !== 0);
  },
  14: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3;
  },
  15: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  16: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2;
  },
  17: function(t) {
    return t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1;
  },
  18: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : 2;
  },
  19: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3;
  },
  20: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2;
  },
  21: function(t) {
    return t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0;
  },
  22: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3;
  }
}, nu = ["v1", "v2", "v3"], fo = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function ou() {
  var e = {};
  return tu.forEach(function(t) {
    t.lngs.forEach(function(r) {
      e[r] = {
        numbers: t.nr,
        plurals: ru[t.fc]
      };
    });
  }), e;
}
var iu = (function() {
  function e(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Fe(this, e), this.languageUtils = t, this.options = r, this.logger = Le.create("pluralResolver"), (!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = ou();
  }
  return $e(e, [{
    key: "addRule",
    value: function(r, n) {
      this.rules[r] = n;
    }
  }, {
    key: "getRule",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (this.shouldUseIntlApi())
        try {
          return new Intl.PluralRules(r, {
            type: n.ordinal ? "ordinal" : "cardinal"
          });
        } catch {
          return;
        }
      return this.rules[r] || this.rules[this.languageUtils.getLanguagePartFromCode(r)];
    }
  }, {
    key: "needsPlural",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = this.getRule(r, n);
      return this.shouldUseIntlApi() ? o && o.resolvedOptions().pluralCategories.length > 1 : o && o.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function(r, n) {
      var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this.getSuffixes(r, o).map(function(i) {
        return "".concat(n).concat(i);
      });
    }
  }, {
    key: "getSuffixes",
    value: function(r) {
      var n = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = this.getRule(r, o);
      return i ? this.shouldUseIntlApi() ? i.resolvedOptions().pluralCategories.sort(function(a, s) {
        return fo[a] - fo[s];
      }).map(function(a) {
        return "".concat(n.options.prepend).concat(a);
      }) : i.numbers.map(function(a) {
        return n.getSuffix(r, a, o);
      }) : [];
    }
  }, {
    key: "getSuffix",
    value: function(r, n) {
      var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = this.getRule(r, o);
      return i ? this.shouldUseIntlApi() ? "".concat(this.options.prepend).concat(i.select(n)) : this.getSuffixRetroCompatible(i, n) : (this.logger.warn("no plural rule found for: ".concat(r)), "");
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function(r, n) {
      var o = this, i = r.noAbs ? r.plurals(n) : r.plurals(Math.abs(n)), a = r.numbers[i];
      this.options.simplifyPluralSuffix && r.numbers.length === 2 && r.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
      var s = function() {
        return o.options.prepend && a.toString() ? o.options.prepend + a.toString() : a.toString();
      };
      return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? "_plural_".concat(a.toString()) : s() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && r.numbers.length === 2 && r.numbers[0] === 1 ? s() : this.options.prepend && i.toString() ? this.options.prepend + i.toString() : i.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function() {
      return !nu.includes(this.options.compatibilityJSON);
    }
  }]), e;
})();
function po(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? po(Object(r), !0).forEach(function(n) {
      et(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : po(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function go(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = Uc(e, t, r);
  return !i && o && typeof r == "string" && (i = er(e, r, n), i === void 0 && (i = er(t, r, n))), i;
}
var au = (function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Fe(this, e), this.logger = Le.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function(r) {
      return r;
    }, this.init(t);
  }
  return $e(e, [{
    key: "init",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      r.interpolation || (r.interpolation = {
        escapeValue: !0
      });
      var n = r.interpolation;
      this.escape = n.escape !== void 0 ? n.escape : Kc, this.escapeValue = n.escapeValue !== void 0 ? n.escapeValue : !0, this.useRawValueToEscape = n.useRawValueToEscape !== void 0 ? n.useRawValueToEscape : !1, this.prefix = n.prefix ? gt(n.prefix) : n.prefixEscaped || "{{", this.suffix = n.suffix ? gt(n.suffix) : n.suffixEscaped || "}}", this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",", this.unescapePrefix = n.unescapeSuffix ? "" : n.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : n.unescapeSuffix || "", this.nestingPrefix = n.nestingPrefix ? gt(n.nestingPrefix) : n.nestingPrefixEscaped || gt("$t("), this.nestingSuffix = n.nestingSuffix ? gt(n.nestingSuffix) : n.nestingSuffixEscaped || gt(")"), this.nestingOptionsSeparator = n.nestingOptionsSeparator ? n.nestingOptionsSeparator : n.nestingOptionsSeparator || ",", this.maxReplaces = n.maxReplaces ? n.maxReplaces : 1e3, this.alwaysFormat = n.alwaysFormat !== void 0 ? n.alwaysFormat : !1, this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function() {
      this.options && this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function() {
      var r = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(r, "g");
      var n = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(n, "g");
      var o = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(o, "g");
    }
  }, {
    key: "interpolate",
    value: function(r, n, o, i) {
      var a = this, s, l, u, c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function f(w) {
        return w.replace(/\$/g, "$$$$");
      }
      var d = function(v) {
        if (v.indexOf(a.formatSeparator) < 0) {
          var y = go(n, c, v, a.options.keySeparator, a.options.ignoreJSONStructure);
          return a.alwaysFormat ? a.format(y, void 0, o, Re(Re(Re({}, i), n), {}, {
            interpolationkey: v
          })) : y;
        }
        var C = v.split(a.formatSeparator), S = C.shift().trim(), O = C.join(a.formatSeparator).trim();
        return a.format(go(n, c, S, a.options.keySeparator, a.options.ignoreJSONStructure), O, o, Re(Re(Re({}, i), n), {}, {
          interpolationkey: S
        }));
      };
      this.resetRegExp();
      var g = i && i.missingInterpolationHandler || this.options.missingInterpolationHandler, b = i && i.interpolation && i.interpolation.skipOnVariables !== void 0 ? i.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables, m = [{
        regex: this.regexpUnescape,
        safeValue: function(v) {
          return f(v);
        }
      }, {
        regex: this.regexp,
        safeValue: function(v) {
          return a.escapeValue ? f(a.escape(v)) : f(v);
        }
      }];
      return m.forEach(function(w) {
        for (u = 0; s = w.regex.exec(r); ) {
          var v = s[1].trim();
          if (l = d(v), l === void 0)
            if (typeof g == "function") {
              var y = g(r, s, i);
              l = typeof y == "string" ? y : "";
            } else if (i && Object.prototype.hasOwnProperty.call(i, v))
              l = "";
            else if (b) {
              l = s[0];
              continue;
            } else
              a.logger.warn("missed to pass in variable ".concat(v, " for interpolating ").concat(r)), l = "";
          else typeof l != "string" && !a.useRawValueToEscape && (l = oo(l));
          var C = w.safeValue(l);
          if (r = r.replace(s[0], C), b ? (w.regex.lastIndex += l.length, w.regex.lastIndex -= s[0].length) : w.regex.lastIndex = 0, u++, u >= a.maxReplaces)
            break;
        }
      }), r;
    }
  }, {
    key: "nest",
    value: function(r, n) {
      var o = this, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, s, l;
      function u(g, b) {
        var m = this.nestingOptionsSeparator;
        if (g.indexOf(m) < 0) return g;
        var w = g.split(new RegExp("".concat(m, "[ ]*{"))), v = "{".concat(w[1]);
        g = w[0], v = this.interpolate(v, l);
        var y = v.match(/'/g), C = v.match(/"/g);
        (y && y.length % 2 === 0 && !C || C.length % 2 !== 0) && (v = v.replace(/'/g, '"'));
        try {
          l = JSON.parse(v), b && (l = Re(Re({}, b), l));
        } catch (S) {
          return this.logger.warn("failed parsing options string in nesting for key ".concat(g), S), "".concat(g).concat(m).concat(v);
        }
        return delete l.defaultValue, g;
      }
      for (; a = this.nestingRegexp.exec(r); ) {
        var c = [];
        l = Re({}, i), l = l.replace && typeof l.replace != "string" ? l.replace : l, l.applyPostProcessor = !1, delete l.defaultValue;
        var f = !1;
        if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
          var d = a[1].split(this.formatSeparator).map(function(g) {
            return g.trim();
          });
          a[1] = d.shift(), c = d, f = !0;
        }
        if (s = n(u.call(this, a[1].trim(), l), l), s && a[0] === r && typeof s != "string") return s;
        typeof s != "string" && (s = oo(s)), s || (this.logger.warn("missed to resolve ".concat(a[1], " for nesting ").concat(r)), s = ""), f && (s = c.reduce(function(g, b) {
          return o.format(g, b, i.lng, Re(Re({}, i), {}, {
            interpolationkey: a[1].trim()
          }));
        }, s.trim())), r = r.replace(a[0], s), this.regexp.lastIndex = 0;
      }
      return r;
    }
  }]), e;
})();
function ho(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function He(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ho(Object(r), !0).forEach(function(n) {
      et(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ho(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function su(e) {
  var t = e.toLowerCase().trim(), r = {};
  if (e.indexOf("(") > -1) {
    var n = e.split("(");
    t = n[0].toLowerCase().trim();
    var o = n[1].substring(0, n[1].length - 1);
    if (t === "currency" && o.indexOf(":") < 0)
      r.currency || (r.currency = o.trim());
    else if (t === "relativetime" && o.indexOf(":") < 0)
      r.range || (r.range = o.trim());
    else {
      var i = o.split(";");
      i.forEach(function(a) {
        if (a) {
          var s = a.split(":"), l = Wc(s), u = l[0], c = l.slice(1), f = c.join(":").trim().replace(/^'+|'+$/g, "");
          r[u.trim()] || (r[u.trim()] = f), f === "false" && (r[u.trim()] = !1), f === "true" && (r[u.trim()] = !0), isNaN(f) || (r[u.trim()] = parseInt(f, 10));
        }
      });
    }
  }
  return {
    formatName: t,
    formatOptions: r
  };
}
function ht(e) {
  var t = {};
  return function(n, o, i) {
    var a = o + JSON.stringify(i), s = t[a];
    return s || (s = e(o, i), t[a] = s), s(n);
  };
}
var lu = (function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Fe(this, e), this.logger = Le.create("formatter"), this.options = t, this.formats = {
      number: ht(function(r, n) {
        var o = new Intl.NumberFormat(r, He({}, n));
        return function(i) {
          return o.format(i);
        };
      }),
      currency: ht(function(r, n) {
        var o = new Intl.NumberFormat(r, He(He({}, n), {}, {
          style: "currency"
        }));
        return function(i) {
          return o.format(i);
        };
      }),
      datetime: ht(function(r, n) {
        var o = new Intl.DateTimeFormat(r, He({}, n));
        return function(i) {
          return o.format(i);
        };
      }),
      relativetime: ht(function(r, n) {
        var o = new Intl.RelativeTimeFormat(r, He({}, n));
        return function(i) {
          return o.format(i, n.range || "day");
        };
      }),
      list: ht(function(r, n) {
        var o = new Intl.ListFormat(r, He({}, n));
        return function(i) {
          return o.format(i);
        };
      })
    }, this.init(t);
  }
  return $e(e, [{
    key: "init",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      }, o = n.interpolation;
      this.formatSeparator = o.formatSeparator ? o.formatSeparator : o.formatSeparator || ",";
    }
  }, {
    key: "add",
    value: function(r, n) {
      this.formats[r.toLowerCase().trim()] = n;
    }
  }, {
    key: "addCached",
    value: function(r, n) {
      this.formats[r.toLowerCase().trim()] = ht(n);
    }
  }, {
    key: "format",
    value: function(r, n, o) {
      var i = this, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = n.split(this.formatSeparator), l = s.reduce(function(u, c) {
        var f = su(c), d = f.formatName, g = f.formatOptions;
        if (i.formats[d]) {
          var b = u;
          try {
            var m = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, w = m.locale || m.lng || a.locale || a.lng || o;
            b = i.formats[d](u, w, He(He(He({}, g), a), m));
          } catch (v) {
            i.logger.warn(v);
          }
          return b;
        } else
          i.logger.warn("there was no format function for ".concat(d));
        return u;
      }, r);
      return l;
    }
  }]), e;
})();
function mo(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mo(Object(r), !0).forEach(function(n) {
      et(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : mo(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function cu(e) {
  var t = uu();
  return function() {
    var n = De(e), o;
    if (t) {
      var i = De(this).constructor;
      o = Reflect.construct(n, arguments, i);
    } else
      o = n.apply(this, arguments);
    return Lt(this, o);
  };
}
function uu() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function fu(e, t) {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
}
var du = (function(e) {
  fr(r, e);
  var t = cu(r);
  function r(n, o, i) {
    var a, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return Fe(this, r), a = t.call(this), dr && qe.call(Je(a)), a.backend = n, a.store = o, a.services = i, a.languageUtils = i.languageUtils, a.options = s, a.logger = Le.create("backendConnector"), a.waitingReads = [], a.maxParallelReads = s.maxParallelReads || 10, a.readingCalls = 0, a.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, a.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, a.state = {}, a.queue = [], a.backend && a.backend.init && a.backend.init(i, s.backend, s), a;
  }
  return $e(r, [{
    key: "queueLoad",
    value: function(o, i, a, s) {
      var l = this, u = {}, c = {}, f = {}, d = {};
      return o.forEach(function(g) {
        var b = !0;
        i.forEach(function(m) {
          var w = "".concat(g, "|").concat(m);
          !a.reload && l.store.hasResourceBundle(g, m) ? l.state[w] = 2 : l.state[w] < 0 || (l.state[w] === 1 ? c[w] === void 0 && (c[w] = !0) : (l.state[w] = 1, b = !1, c[w] === void 0 && (c[w] = !0), u[w] === void 0 && (u[w] = !0), d[m] === void 0 && (d[m] = !0)));
        }), b || (f[g] = !0);
      }), (Object.keys(u).length || Object.keys(c).length) && this.queue.push({
        pending: c,
        pendingCount: Object.keys(c).length,
        loaded: {},
        errors: [],
        callback: s
      }), {
        toLoad: Object.keys(u),
        pending: Object.keys(c),
        toLoadLanguages: Object.keys(f),
        toLoadNamespaces: Object.keys(d)
      };
    }
  }, {
    key: "loaded",
    value: function(o, i, a) {
      var s = o.split("|"), l = s[0], u = s[1];
      i && this.emit("failedLoading", l, u, i), a && this.store.addResourceBundle(l, u, a), this.state[o] = i ? -1 : 2;
      var c = {};
      this.queue.forEach(function(f) {
        Hc(f.loaded, [l], u), fu(f, o), i && f.errors.push(i), f.pendingCount === 0 && !f.done && (Object.keys(f.loaded).forEach(function(d) {
          c[d] || (c[d] = {});
          var g = f.loaded[d];
          g.length && g.forEach(function(b) {
            c[d][b] === void 0 && (c[d][b] = !0);
          });
        }), f.done = !0, f.errors.length ? f.callback(f.errors) : f.callback());
      }), this.emit("loaded", c), this.queue = this.queue.filter(function(f) {
        return !f.done;
      });
    }
  }, {
    key: "read",
    value: function(o, i, a) {
      var s = this, l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, u = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, c = arguments.length > 5 ? arguments[5] : void 0;
      if (!o.length) return c(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: o,
          ns: i,
          fcName: a,
          tried: l,
          wait: u,
          callback: c
        });
        return;
      }
      this.readingCalls++;
      var f = function(m, w) {
        if (s.readingCalls--, s.waitingReads.length > 0) {
          var v = s.waitingReads.shift();
          s.read(v.lng, v.ns, v.fcName, v.tried, v.wait, v.callback);
        }
        if (m && w && l < s.maxRetries) {
          setTimeout(function() {
            s.read.call(s, o, i, a, l + 1, u * 2, c);
          }, u);
          return;
        }
        c(m, w);
      }, d = this.backend[a].bind(this.backend);
      if (d.length === 2) {
        try {
          var g = d(o, i);
          g && typeof g.then == "function" ? g.then(function(b) {
            return f(null, b);
          }).catch(f) : f(null, g);
        } catch (b) {
          f(b);
        }
        return;
      }
      return d(o, i, f);
    }
  }, {
    key: "prepareLoading",
    value: function(o, i) {
      var a = this, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend)
        return this.logger.warn("No backend was added via i18next.use. Will not load resources."), l && l();
      typeof o == "string" && (o = this.languageUtils.toResolveHierarchy(o)), typeof i == "string" && (i = [i]);
      var u = this.queueLoad(o, i, s, l);
      if (!u.toLoad.length)
        return u.pending.length || l(), null;
      u.toLoad.forEach(function(c) {
        a.loadOne(c);
      });
    }
  }, {
    key: "load",
    value: function(o, i, a) {
      this.prepareLoading(o, i, {}, a);
    }
  }, {
    key: "reload",
    value: function(o, i, a) {
      this.prepareLoading(o, i, {
        reload: !0
      }, a);
    }
  }, {
    key: "loadOne",
    value: function(o) {
      var i = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", s = o.split("|"), l = s[0], u = s[1];
      this.read(l, u, "read", void 0, void 0, function(c, f) {
        c && i.logger.warn("".concat(a, "loading namespace ").concat(u, " for language ").concat(l, " failed"), c), !c && f && i.logger.log("".concat(a, "loaded namespace ").concat(u, " for language ").concat(l), f), i.loaded(o, c, f);
      });
    }
  }, {
    key: "saveMissing",
    value: function(o, i, a, s, l) {
      var u = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, c = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : function() {
      };
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(i)) {
        this.logger.warn('did not save key "'.concat(a, '" as the namespace "').concat(i, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      if (!(a == null || a === "")) {
        if (this.backend && this.backend.create) {
          var f = vo(vo({}, u), {}, {
            isUpdate: l
          }), d = this.backend.create.bind(this.backend);
          if (d.length < 6)
            try {
              var g;
              d.length === 5 ? g = d(o, i, a, s, f) : g = d(o, i, a, s), g && typeof g.then == "function" ? g.then(function(b) {
                return c(null, b);
              }).catch(c) : c(null, g);
            } catch (b) {
              c(b);
            }
          else
            d(o, i, a, s, c, f);
        }
        !o || !o[0] || this.store.addResource(o[0], i, a, s);
      }
    }
  }]), r;
})(qe);
function bo() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !0,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(t) {
      var r = {};
      if (xe(t[1]) === "object" && (r = t[1]), typeof t[1] == "string" && (r.defaultValue = t[1]), typeof t[2] == "string" && (r.tDescription = t[2]), xe(t[2]) === "object" || xe(t[3]) === "object") {
        var n = t[3] || t[2];
        Object.keys(n).forEach(function(o) {
          r[o] = n[o];
        });
      }
      return r;
    },
    interpolation: {
      escapeValue: !0,
      format: function(t, r, n, o) {
        return t;
      },
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function yo(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function wo(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Te(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wo(Object(r), !0).forEach(function(n) {
      et(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : wo(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pu(e) {
  var t = gu();
  return function() {
    var n = De(e), o;
    if (t) {
      var i = De(this).constructor;
      o = Reflect.construct(n, arguments, i);
    } else
      o = n.apply(this, arguments);
    return Lt(this, o);
  };
}
function gu() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Yt() {
}
function hu(e) {
  var t = Object.getOwnPropertyNames(Object.getPrototypeOf(e));
  t.forEach(function(r) {
    typeof e[r] == "function" && (e[r] = e[r].bind(e));
  });
}
var tr = (function(e) {
  fr(r, e);
  var t = pu(r);
  function r() {
    var n, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0;
    if (Fe(this, r), n = t.call(this), dr && qe.call(Je(n)), n.options = yo(o), n.services = {}, n.logger = Le, n.modules = {
      external: []
    }, hu(Je(n)), i && !n.isInitialized && !o.isClone) {
      if (!n.options.initImmediate)
        return n.init(o, i), Lt(n, Je(n));
      setTimeout(function() {
        n.init(o, i);
      }, 0);
    }
    return n;
  }
  return $e(r, [{
    key: "init",
    value: function() {
      var o = this, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 ? arguments[1] : void 0;
      typeof i == "function" && (a = i, i = {}), !i.defaultNS && i.defaultNS !== !1 && i.ns && (typeof i.ns == "string" ? i.defaultNS = i.ns : i.ns.indexOf("translation") < 0 && (i.defaultNS = i.ns[0]));
      var s = bo();
      this.options = Te(Te(Te({}, s), this.options), yo(i)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = Te(Te({}, s.interpolation), this.options.interpolation)), i.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = i.keySeparator), i.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = i.nsSeparator);
      function l(v) {
        return v ? typeof v == "function" ? new v() : v : null;
      }
      if (!this.options.isClone) {
        this.modules.logger ? Le.init(l(this.modules.logger), this.options) : Le.init(null, this.options);
        var u;
        this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = lu);
        var c = new uo(this.options);
        this.store = new Zc(this.options.resources, this.options);
        var f = this.services;
        f.logger = Le, f.resourceStore = this.store, f.languageUtils = c, f.pluralResolver = new iu(c, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        }), u && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (f.formatter = l(u), f.formatter.init(f, this.options), this.options.interpolation.format = f.formatter.format.bind(f.formatter)), f.interpolator = new au(this.options), f.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        }, f.backendConnector = new du(l(this.modules.backend), f.resourceStore, f, this.options), f.backendConnector.on("*", function(v) {
          for (var y = arguments.length, C = new Array(y > 1 ? y - 1 : 0), S = 1; S < y; S++)
            C[S - 1] = arguments[S];
          o.emit.apply(o, [v].concat(C));
        }), this.modules.languageDetector && (f.languageDetector = l(this.modules.languageDetector), f.languageDetector.init && f.languageDetector.init(f, this.options.detection, this.options)), this.modules.i18nFormat && (f.i18nFormat = l(this.modules.i18nFormat), f.i18nFormat.init && f.i18nFormat.init(this)), this.translator = new co(this.services, this.options), this.translator.on("*", function(v) {
          for (var y = arguments.length, C = new Array(y > 1 ? y - 1 : 0), S = 1; S < y; S++)
            C[S - 1] = arguments[S];
          o.emit.apply(o, [v].concat(C));
        }), this.modules.external.forEach(function(v) {
          v.init && v.init(o);
        });
      }
      if (this.format = this.options.interpolation.format, a || (a = Yt), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var d = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        d.length > 0 && d[0] !== "dev" && (this.options.lng = d[0]);
      }
      !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined");
      var g = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
      g.forEach(function(v) {
        o[v] = function() {
          var y;
          return (y = o.store)[v].apply(y, arguments);
        };
      });
      var b = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
      b.forEach(function(v) {
        o[v] = function() {
          var y;
          return (y = o.store)[v].apply(y, arguments), o;
        };
      });
      var m = kt(), w = function() {
        var y = function(S, O) {
          o.isInitialized && !o.initializedStoreOnce && o.logger.warn("init: i18next is already initialized. You should call init just once!"), o.isInitialized = !0, o.options.isClone || o.logger.log("initialized", o.options), o.emit("initialized", o.options), m.resolve(O), a(S, O);
        };
        if (o.languages && o.options.compatibilityAPI !== "v1" && !o.isInitialized) return y(null, o.t.bind(o));
        o.changeLanguage(o.options.lng, y);
      };
      return this.options.resources || !this.options.initImmediate ? w() : setTimeout(w, 0), m;
    }
  }, {
    key: "loadResources",
    value: function(o) {
      var i = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Yt, s = a, l = typeof o == "string" ? o : this.language;
      if (typeof o == "function" && (s = o), !this.options.resources || this.options.partialBundledLanguages) {
        if (l && l.toLowerCase() === "cimode") return s();
        var u = [], c = function(g) {
          if (g) {
            var b = i.services.languageUtils.toResolveHierarchy(g);
            b.forEach(function(m) {
              u.indexOf(m) < 0 && u.push(m);
            });
          }
        };
        if (l)
          c(l);
        else {
          var f = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          f.forEach(function(d) {
            return c(d);
          });
        }
        this.options.preload && this.options.preload.forEach(function(d) {
          return c(d);
        }), this.services.backendConnector.load(u, this.options.ns, function(d) {
          !d && !i.resolvedLanguage && i.language && i.setResolvedLanguage(i.language), s(d);
        });
      } else
        s(null);
    }
  }, {
    key: "reloadResources",
    value: function(o, i, a) {
      var s = kt();
      return o || (o = this.languages), i || (i = this.options.ns), a || (a = Yt), this.services.backendConnector.reload(o, i, function(l) {
        s.resolve(), a(l);
      }), s;
    }
  }, {
    key: "use",
    value: function(o) {
      if (!o) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!o.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      return o.type === "backend" && (this.modules.backend = o), (o.type === "logger" || o.log && o.warn && o.error) && (this.modules.logger = o), o.type === "languageDetector" && (this.modules.languageDetector = o), o.type === "i18nFormat" && (this.modules.i18nFormat = o), o.type === "postProcessor" && Ii.addPostProcessor(o), o.type === "formatter" && (this.modules.formatter = o), o.type === "3rdParty" && this.modules.external.push(o), this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function(o) {
      if (!(!o || !this.languages) && !(["cimode", "dev"].indexOf(o) > -1))
        for (var i = 0; i < this.languages.length; i++) {
          var a = this.languages[i];
          if (!(["cimode", "dev"].indexOf(a) > -1) && this.store.hasLanguageSomeTranslations(a)) {
            this.resolvedLanguage = a;
            break;
          }
        }
    }
  }, {
    key: "changeLanguage",
    value: function(o, i) {
      var a = this;
      this.isLanguageChangingTo = o;
      var s = kt();
      this.emit("languageChanging", o);
      var l = function(d) {
        a.language = d, a.languages = a.services.languageUtils.toResolveHierarchy(d), a.resolvedLanguage = void 0, a.setResolvedLanguage(d);
      }, u = function(d, g) {
        g ? (l(g), a.translator.changeLanguage(g), a.isLanguageChangingTo = void 0, a.emit("languageChanged", g), a.logger.log("languageChanged", g)) : a.isLanguageChangingTo = void 0, s.resolve(function() {
          return a.t.apply(a, arguments);
        }), i && i(d, function() {
          return a.t.apply(a, arguments);
        });
      }, c = function(d) {
        !o && !d && a.services.languageDetector && (d = []);
        var g = typeof d == "string" ? d : a.services.languageUtils.getBestMatchFromCodes(d);
        g && (a.language || l(g), a.translator.language || a.translator.changeLanguage(g), a.services.languageDetector && a.services.languageDetector.cacheUserLanguage && a.services.languageDetector.cacheUserLanguage(g)), a.loadResources(g, function(b) {
          u(b, g);
        });
      };
      return !o && this.services.languageDetector && !this.services.languageDetector.async ? c(this.services.languageDetector.detect()) : !o && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(c) : this.services.languageDetector.detect(c) : c(o), s;
    }
  }, {
    key: "getFixedT",
    value: function(o, i, a) {
      var s = this, l = function u(c, f) {
        var d;
        if (xe(f) !== "object") {
          for (var g = arguments.length, b = new Array(g > 2 ? g - 2 : 0), m = 2; m < g; m++)
            b[m - 2] = arguments[m];
          d = s.options.overloadTranslationOptionHandler([c, f].concat(b));
        } else
          d = Te({}, f);
        d.lng = d.lng || u.lng, d.lngs = d.lngs || u.lngs, d.ns = d.ns || u.ns, d.keyPrefix = d.keyPrefix || a || u.keyPrefix;
        var w = s.options.keySeparator || ".", v;
        return d.keyPrefix && Array.isArray(c) ? v = c.map(function(y) {
          return "".concat(d.keyPrefix).concat(w).concat(y);
        }) : v = d.keyPrefix ? "".concat(d.keyPrefix).concat(w).concat(c) : c, s.t(v, d);
      };
      return typeof o == "string" ? l.lng = o : l.lngs = o, l.ns = i, l.keyPrefix = a, l;
    }
  }, {
    key: "t",
    value: function() {
      var o;
      return this.translator && (o = this.translator).translate.apply(o, arguments);
    }
  }, {
    key: "exists",
    value: function() {
      var o;
      return this.translator && (o = this.translator).exists.apply(o, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function(o) {
      this.options.defaultNS = o;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function(o) {
      var i = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized)
        return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
      if (!this.languages || !this.languages.length)
        return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
      var s = a.lng || this.resolvedLanguage || this.languages[0], l = this.options ? this.options.fallbackLng : !1, u = this.languages[this.languages.length - 1];
      if (s.toLowerCase() === "cimode") return !0;
      var c = function(g, b) {
        var m = i.services.backendConnector.state["".concat(g, "|").concat(b)];
        return m === -1 || m === 2;
      };
      if (a.precheck) {
        var f = a.precheck(this, c);
        if (f !== void 0) return f;
      }
      return !!(this.hasResourceBundle(s, o) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || c(s, o) && (!l || c(u, o)));
    }
  }, {
    key: "loadNamespaces",
    value: function(o, i) {
      var a = this, s = kt();
      return this.options.ns ? (typeof o == "string" && (o = [o]), o.forEach(function(l) {
        a.options.ns.indexOf(l) < 0 && a.options.ns.push(l);
      }), this.loadResources(function(l) {
        s.resolve(), i && i(l);
      }), s) : (i && i(), Promise.resolve());
    }
  }, {
    key: "loadLanguages",
    value: function(o, i) {
      var a = kt();
      typeof o == "string" && (o = [o]);
      var s = this.options.preload || [], l = o.filter(function(u) {
        return s.indexOf(u) < 0;
      });
      return l.length ? (this.options.preload = s.concat(l), this.loadResources(function(u) {
        a.resolve(), i && i(u);
      }), a) : (i && i(), Promise.resolve());
    }
  }, {
    key: "dir",
    value: function(o) {
      if (o || (o = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !o) return "rtl";
      var i = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], a = this.services && this.services.languageUtils || new uo(bo());
      return i.indexOf(a.getLanguagePartFromCode(o)) > -1 || o.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
  }, {
    key: "cloneInstance",
    value: function() {
      var o = this, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Yt, s = Te(Te(Te({}, this.options), i), {
        isClone: !0
      }), l = new r(s);
      (i.debug !== void 0 || i.prefix !== void 0) && (l.logger = l.logger.clone(i));
      var u = ["store", "services", "language"];
      return u.forEach(function(c) {
        l[c] = o[c];
      }), l.services = Te({}, this.services), l.services.utils = {
        hasLoadedNamespace: l.hasLoadedNamespace.bind(l)
      }, l.translator = new co(l.services, l.options), l.translator.on("*", function(c) {
        for (var f = arguments.length, d = new Array(f > 1 ? f - 1 : 0), g = 1; g < f; g++)
          d[g - 1] = arguments[g];
        l.emit.apply(l, [c].concat(d));
      }), l.init(s, a), l.translator.options = l.options, l.translator.backendConnector.services.utils = {
        hasLoadedNamespace: l.hasLoadedNamespace.bind(l)
      }, l;
    }
  }, {
    key: "toJSON",
    value: function() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]), r;
})(qe);
et(tr, "createInstance", function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
  return new tr(e, t);
});
var fe = tr.createInstance();
fe.createInstance = tr.createInstance;
fe.createInstance;
fe.dir;
fe.init;
fe.loadResources;
fe.reloadResources;
fe.use;
fe.changeLanguage;
fe.getFixedT;
var mu = fe.t;
fe.exists;
fe.setDefaultNamespace;
fe.hasLoadedNamespace;
fe.loadNamespaces;
fe.loadLanguages;
const Mi = es({}), vu = () => ts(Mi).container;
function zd({ ...e }) {
  return /* @__PURE__ */ x.jsx(wc, { "data-slot": "dialog", ...e });
}
function Bd({ ...e }) {
  return /* @__PURE__ */ x.jsx(xc, { "data-slot": "dialog-trigger", ...e });
}
function bu({ ...e }) {
  return /* @__PURE__ */ x.jsx(Sc, { "data-slot": "dialog-portal", ...e });
}
function Vd({ ...e }) {
  return /* @__PURE__ */ x.jsx(Ni, { "data-slot": "dialog-close", ...e });
}
const Fi = `data-[state=open]:animate-in data-[state=closed]:animate-out
              data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50`, $i = p.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ x.jsx(
  Ei,
  {
    ref: r,
    "data-slot": "dialog-overlay",
    className: ue(Fi, e),
    ...t
  }
));
$i.displayName = Ei.displayName;
const yu = p.forwardRef(
  ({ className: e, showCloseButton: t = !0, children: r, container: n, lockScroll: o = !0, ...i }, a) => {
    const s = vu(), l = n || s || void 0;
    return /* @__PURE__ */ x.jsxs(bu, { "data-slot": "dialog-portal", container: l, children: [
      o ? /* @__PURE__ */ x.jsx($i, {}) : /* @__PURE__ */ x.jsx("div", { className: ue(Fi) }),
      /* @__PURE__ */ x.jsxs(
        ki,
        {
          ref: a,
          "data-slot": "dialog-content",
          className: ue(
            `bg-background data-[state=open]:animate-in data-[state=closed]:animate-out
            data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95
            data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2
            data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2
            data-[state=open]:slide-in-from-top-[48%] fixed left-[50%] top-[50%] z-50 grid w-full
            max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] rounded-2xl border p-6
            shadow-lg duration-200 sm:max-w-2xl`,
            e
          ),
          ...i,
          children: [
            r,
            t && /* @__PURE__ */ x.jsxs(
              Ni,
              {
                "data-slot": "dialog-close",
                className: `ring-offset-background focus:ring-ring data-[state=open]:bg-accent
                data-[state=open]:text-muted-foreground rounded-xs focus:outline-hidden absolute right-4
                top-4 opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2
                disabled:pointer-events-none [&_svg:not([class*='size-'])]:size-4
                [&_svg]:pointer-events-none [&_svg]:shrink-0`,
                children: [
                  /* @__PURE__ */ x.jsx(Nc, {}),
                  /* @__PURE__ */ x.jsx("span", { className: "sr-only", children: mu("close") })
                ]
              }
            )
          ]
        }
      )
    ] });
  }
);
yu.displayName = ki.displayName;
const wu = ({ className: e, ...t }) => /* @__PURE__ */ x.jsx(
  "div",
  {
    "data-slot": "dialog-header",
    className: ue("flex flex-col gap-2 text-center sm:text-left", e),
    ...t
  }
);
wu.displayName = "DialogHeader";
const xu = ({ className: e, ...t }) => /* @__PURE__ */ x.jsx(
  "div",
  {
    "data-slot": "dialog-footer",
    className: ue("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", e),
    ...t
  }
);
xu.displayName = "DialogFooter";
const Su = p.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ x.jsx(
  Ai,
  {
    ref: r,
    "data-slot": "dialog-title",
    className: ue("text-lg font-semibold leading-none", e),
    ...t
  }
));
Su.displayName = Ai.displayName;
const Cu = p.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ x.jsx(
  Ti,
  {
    ref: r,
    "data-slot": "dialog-description",
    className: ue("text-muted-foreground text-sm", e),
    ...t
  }
));
Cu.displayName = Ti.displayName;
const Ru = ({ children: e }) => /* @__PURE__ */ x.jsx(nn, { children: e });
Ru.displayName = "DialogVisuallyHidden";
function Hd({ className: e, ...t }) {
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      "data-slot": "skeleton",
      className: ue("bg-accent animate-pulse rounded-md", e),
      ...t
    }
  );
}
const Ou = ["top", "right", "bottom", "left"], Ze = Math.min, ve = Math.max, rr = Math.round, Kt = Math.floor, je = (e) => ({
  x: e,
  y: e
}), Pu = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Eu = {
  start: "end",
  end: "start"
};
function Ur(e, t, r) {
  return ve(e, Ze(t, r));
}
function Ye(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ke(e) {
  return e.split("-")[0];
}
function Ct(e) {
  return e.split("-")[1];
}
function an(e) {
  return e === "x" ? "y" : "x";
}
function sn(e) {
  return e === "y" ? "height" : "width";
}
const ku = /* @__PURE__ */ new Set(["top", "bottom"]);
function _e(e) {
  return ku.has(Ke(e)) ? "y" : "x";
}
function ln(e) {
  return an(_e(e));
}
function Au(e, t, r) {
  r === void 0 && (r = !1);
  const n = Ct(e), o = ln(e), i = sn(o);
  let a = o === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = nr(a)), [a, nr(a)];
}
function Tu(e) {
  const t = nr(e);
  return [Yr(e), t, Yr(t)];
}
function Yr(e) {
  return e.replace(/start|end/g, (t) => Eu[t]);
}
const xo = ["left", "right"], So = ["right", "left"], Nu = ["top", "bottom"], Lu = ["bottom", "top"];
function _u(e, t, r) {
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? So : xo : t ? xo : So;
    case "left":
    case "right":
      return t ? Nu : Lu;
    default:
      return [];
  }
}
function ju(e, t, r, n) {
  const o = Ct(e);
  let i = _u(Ke(e), r === "start", n);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(Yr)))), i;
}
function nr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Pu[t]);
}
function Du(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Wi(e) {
  return typeof e != "number" ? Du(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function or(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: o
  } = e;
  return {
    width: n,
    height: o,
    top: r,
    left: t,
    right: t + n,
    bottom: r + o,
    x: t,
    y: r
  };
}
function Co(e, t, r) {
  let {
    reference: n,
    floating: o
  } = e;
  const i = _e(t), a = ln(t), s = sn(a), l = Ke(t), u = i === "y", c = n.x + n.width / 2 - o.width / 2, f = n.y + n.height / 2 - o.height / 2, d = n[s] / 2 - o[s] / 2;
  let g;
  switch (l) {
    case "top":
      g = {
        x: c,
        y: n.y - o.height
      };
      break;
    case "bottom":
      g = {
        x: c,
        y: n.y + n.height
      };
      break;
    case "right":
      g = {
        x: n.x + n.width,
        y: f
      };
      break;
    case "left":
      g = {
        x: n.x - o.width,
        y: f
      };
      break;
    default:
      g = {
        x: n.x,
        y: n.y
      };
  }
  switch (Ct(t)) {
    case "start":
      g[a] -= d * (r && u ? -1 : 1);
      break;
    case "end":
      g[a] += d * (r && u ? -1 : 1);
      break;
  }
  return g;
}
const Iu = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = r, s = i.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let u = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: c,
    y: f
  } = Co(u, n, l), d = n, g = {}, b = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: w,
      fn: v
    } = s[m], {
      x: y,
      y: C,
      data: S,
      reset: O
    } = await v({
      x: c,
      y: f,
      initialPlacement: n,
      placement: d,
      strategy: o,
      middlewareData: g,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = y ?? c, f = C ?? f, g = {
      ...g,
      [w]: {
        ...g[w],
        ...S
      }
    }, O && b <= 50 && (b++, typeof O == "object" && (O.placement && (d = O.placement), O.rects && (u = O.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : O.rects), {
      x: c,
      y: f
    } = Co(u, d, l)), m = -1);
  }
  return {
    x: c,
    y: f,
    placement: d,
    strategy: o,
    middlewareData: g
  };
};
async function At(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: f = "floating",
    altBoundary: d = !1,
    padding: g = 0
  } = Ye(t, e), b = Wi(g), w = s[d ? f === "floating" ? "reference" : "floating" : f], v = or(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(w))) == null || r ? w : w.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: l
  })), y = f === "floating" ? {
    x: n,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), S = await (i.isElement == null ? void 0 : i.isElement(C)) ? await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, O = or(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: C,
    strategy: l
  }) : y);
  return {
    top: (v.top - O.top + b.top) / S.y,
    bottom: (O.bottom - v.bottom + b.bottom) / S.y,
    left: (v.left - O.left + b.left) / S.x,
    right: (O.right - v.right + b.right) / S.x
  };
}
const Mu = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: o,
      rects: i,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: c = 0
    } = Ye(e, t) || {};
    if (u == null)
      return {};
    const f = Wi(c), d = {
      x: r,
      y: n
    }, g = ln(o), b = sn(g), m = await a.getDimensions(u), w = g === "y", v = w ? "top" : "left", y = w ? "bottom" : "right", C = w ? "clientHeight" : "clientWidth", S = i.reference[b] + i.reference[g] - d[g] - i.floating[b], O = d[g] - i.reference[g], T = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u));
    let k = T ? T[C] : 0;
    (!k || !await (a.isElement == null ? void 0 : a.isElement(T))) && (k = s.floating[C] || i.floating[b]);
    const E = S / 2 - O / 2, _ = k / 2 - m[b] / 2 - 1, j = Ze(f[v], _), V = Ze(f[y], _), Y = j, B = k - m[b] - V, I = k / 2 - m[b] / 2 + E, K = Ur(Y, I, B), F = !l.arrow && Ct(o) != null && I !== K && i.reference[b] / 2 - (I < Y ? j : V) - m[b] / 2 < 0, $ = F ? I < Y ? I - Y : I - B : 0;
    return {
      [g]: d[g] + $,
      data: {
        [g]: K,
        centerOffset: I - K - $,
        ...F && {
          alignmentOffset: $
        }
      },
      reset: F
    };
  }
}), Fu = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: c = !0,
        crossAxis: f = !0,
        fallbackPlacements: d,
        fallbackStrategy: g = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: m = !0,
        ...w
      } = Ye(e, t);
      if ((r = i.arrow) != null && r.alignmentOffset)
        return {};
      const v = Ke(o), y = _e(s), C = Ke(s) === s, S = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), O = d || (C || !m ? [nr(s)] : Tu(s)), T = b !== "none";
      !d && T && O.push(...ju(s, m, b, S));
      const k = [s, ...O], E = await At(t, w), _ = [];
      let j = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (c && _.push(E[v]), f) {
        const I = Au(o, a, S);
        _.push(E[I[0]], E[I[1]]);
      }
      if (j = [...j, {
        placement: o,
        overflows: _
      }], !_.every((I) => I <= 0)) {
        var V, Y;
        const I = (((V = i.flip) == null ? void 0 : V.index) || 0) + 1, K = k[I];
        if (K && (!(f === "alignment" ? y !== _e(K) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        j.every((P) => _e(P.placement) === y ? P.overflows[0] > 0 : !0)))
          return {
            data: {
              index: I,
              overflows: j
            },
            reset: {
              placement: K
            }
          };
        let F = (Y = j.filter(($) => $.overflows[0] <= 0).sort(($, P) => $.overflows[1] - P.overflows[1])[0]) == null ? void 0 : Y.placement;
        if (!F)
          switch (g) {
            case "bestFit": {
              var B;
              const $ = (B = j.filter((P) => {
                if (T) {
                  const X = _e(P.placement);
                  return X === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  X === "y";
                }
                return !0;
              }).map((P) => [P.placement, P.overflows.filter((X) => X > 0).reduce((X, ne) => X + ne, 0)]).sort((P, X) => P[1] - X[1])[0]) == null ? void 0 : B[0];
              $ && (F = $);
              break;
            }
            case "initialPlacement":
              F = s;
              break;
          }
        if (o !== F)
          return {
            reset: {
              placement: F
            }
          };
      }
      return {};
    }
  };
};
function Ro(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Oo(e) {
  return Ou.some((t) => e[t] >= 0);
}
const $u = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...o
      } = Ye(e, t);
      switch (n) {
        case "referenceHidden": {
          const i = await At(t, {
            ...o,
            elementContext: "reference"
          }), a = Ro(i, r.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: Oo(a)
            }
          };
        }
        case "escaped": {
          const i = await At(t, {
            ...o,
            altBoundary: !0
          }), a = Ro(i, r.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: Oo(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, zi = /* @__PURE__ */ new Set(["left", "top"]);
async function Wu(e, t) {
  const {
    placement: r,
    platform: n,
    elements: o
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), a = Ke(r), s = Ct(r), l = _e(r) === "y", u = zi.has(a) ? -1 : 1, c = i && l ? -1 : 1, f = Ye(t, e);
  let {
    mainAxis: d,
    crossAxis: g,
    alignmentAxis: b
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof b == "number" && (g = s === "end" ? b * -1 : b), l ? {
    x: g * c,
    y: d * u
  } : {
    x: d * u,
    y: g * c
  };
}
const zu = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = t, l = await Wu(t, e);
      return a === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, Bu = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (w) => {
            let {
              x: v,
              y
            } = w;
            return {
              x: v,
              y
            };
          }
        },
        ...l
      } = Ye(e, t), u = {
        x: r,
        y: n
      }, c = await At(t, l), f = _e(Ke(o)), d = an(f);
      let g = u[d], b = u[f];
      if (i) {
        const w = d === "y" ? "top" : "left", v = d === "y" ? "bottom" : "right", y = g + c[w], C = g - c[v];
        g = Ur(y, g, C);
      }
      if (a) {
        const w = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", y = b + c[w], C = b - c[v];
        b = Ur(y, b, C);
      }
      const m = s.fn({
        ...t,
        [d]: g,
        [f]: b
      });
      return {
        ...m,
        data: {
          x: m.x - r,
          y: m.y - n,
          enabled: {
            [d]: i,
            [f]: a
          }
        }
      };
    }
  };
}, Vu = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: o,
        rects: i,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = Ye(e, t), c = {
        x: r,
        y: n
      }, f = _e(o), d = an(f);
      let g = c[d], b = c[f];
      const m = Ye(s, t), w = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const C = d === "y" ? "height" : "width", S = i.reference[d] - i.floating[C] + w.mainAxis, O = i.reference[d] + i.reference[C] - w.mainAxis;
        g < S ? g = S : g > O && (g = O);
      }
      if (u) {
        var v, y;
        const C = d === "y" ? "width" : "height", S = zi.has(Ke(o)), O = i.reference[f] - i.floating[C] + (S && ((v = a.offset) == null ? void 0 : v[f]) || 0) + (S ? 0 : w.crossAxis), T = i.reference[f] + i.reference[C] + (S ? 0 : ((y = a.offset) == null ? void 0 : y[f]) || 0) - (S ? w.crossAxis : 0);
        b < O ? b = O : b > T && (b = T);
      }
      return {
        [d]: g,
        [f]: b
      };
    }
  };
}, Hu = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        rects: i,
        platform: a,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...u
      } = Ye(e, t), c = await At(t, u), f = Ke(o), d = Ct(o), g = _e(o) === "y", {
        width: b,
        height: m
      } = i.floating;
      let w, v;
      f === "top" || f === "bottom" ? (w = f, v = d === (await (a.isRTL == null ? void 0 : a.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (v = f, w = d === "end" ? "top" : "bottom");
      const y = m - c.top - c.bottom, C = b - c.left - c.right, S = Ze(m - c[w], y), O = Ze(b - c[v], C), T = !t.middlewareData.shift;
      let k = S, E = O;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (E = C), (n = t.middlewareData.shift) != null && n.enabled.y && (k = y), T && !d) {
        const j = ve(c.left, 0), V = ve(c.right, 0), Y = ve(c.top, 0), B = ve(c.bottom, 0);
        g ? E = b - 2 * (j !== 0 || V !== 0 ? j + V : ve(c.left, c.right)) : k = m - 2 * (Y !== 0 || B !== 0 ? Y + B : ve(c.top, c.bottom));
      }
      await l({
        ...t,
        availableWidth: E,
        availableHeight: k
      });
      const _ = await a.getDimensions(s.floating);
      return b !== _.width || m !== _.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function pr() {
  return typeof window < "u";
}
function Rt(e) {
  return Bi(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ye(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function We(e) {
  var t;
  return (t = (Bi(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Bi(e) {
  return pr() ? e instanceof Node || e instanceof ye(e).Node : !1;
}
function Oe(e) {
  return pr() ? e instanceof Element || e instanceof ye(e).Element : !1;
}
function Ie(e) {
  return pr() ? e instanceof HTMLElement || e instanceof ye(e).HTMLElement : !1;
}
function Po(e) {
  return !pr() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ye(e).ShadowRoot;
}
const Uu = /* @__PURE__ */ new Set(["inline", "contents"]);
function _t(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: o
  } = Pe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !Uu.has(o);
}
const Yu = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Ku(e) {
  return Yu.has(Rt(e));
}
const Gu = [":popover-open", ":modal"];
function gr(e) {
  return Gu.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Xu = ["transform", "translate", "scale", "rotate", "perspective"], Ju = ["transform", "translate", "scale", "rotate", "perspective", "filter"], qu = ["paint", "layout", "strict", "content"];
function cn(e) {
  const t = un(), r = Oe(e) ? Pe(e) : e;
  return Xu.some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || Ju.some((n) => (r.willChange || "").includes(n)) || qu.some((n) => (r.contain || "").includes(n));
}
function Zu(e) {
  let t = Qe(e);
  for (; Ie(t) && !bt(t); ) {
    if (cn(t))
      return t;
    if (gr(t))
      return null;
    t = Qe(t);
  }
  return null;
}
function un() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Qu = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function bt(e) {
  return Qu.has(Rt(e));
}
function Pe(e) {
  return ye(e).getComputedStyle(e);
}
function hr(e) {
  return Oe(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Qe(e) {
  if (Rt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Po(e) && e.host || // Fallback.
    We(e)
  );
  return Po(t) ? t.host : t;
}
function Vi(e) {
  const t = Qe(e);
  return bt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ie(t) && _t(t) ? t : Vi(t);
}
function Tt(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const o = Vi(e), i = o === ((n = e.ownerDocument) == null ? void 0 : n.body), a = ye(o);
  if (i) {
    const s = Kr(a);
    return t.concat(a, a.visualViewport || [], _t(o) ? o : [], s && r ? Tt(s) : []);
  }
  return t.concat(o, Tt(o, [], r));
}
function Kr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Hi(e) {
  const t = Pe(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = Ie(e), i = o ? e.offsetWidth : r, a = o ? e.offsetHeight : n, s = rr(r) !== i || rr(n) !== a;
  return s && (r = i, n = a), {
    width: r,
    height: n,
    $: s
  };
}
function fn(e) {
  return Oe(e) ? e : e.contextElement;
}
function vt(e) {
  const t = fn(e);
  if (!Ie(t))
    return je(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: i
  } = Hi(t);
  let a = (i ? rr(r.width) : r.width) / n, s = (i ? rr(r.height) : r.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const ef = /* @__PURE__ */ je(0);
function Ui(e) {
  const t = ye(e);
  return !un() || !t.visualViewport ? ef : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function tf(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== ye(e) ? !1 : t;
}
function at(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const o = e.getBoundingClientRect(), i = fn(e);
  let a = je(1);
  t && (n ? Oe(n) && (a = vt(n)) : a = vt(e));
  const s = tf(i, r, n) ? Ui(i) : je(0);
  let l = (o.left + s.x) / a.x, u = (o.top + s.y) / a.y, c = o.width / a.x, f = o.height / a.y;
  if (i) {
    const d = ye(i), g = n && Oe(n) ? ye(n) : n;
    let b = d, m = Kr(b);
    for (; m && n && g !== b; ) {
      const w = vt(m), v = m.getBoundingClientRect(), y = Pe(m), C = v.left + (m.clientLeft + parseFloat(y.paddingLeft)) * w.x, S = v.top + (m.clientTop + parseFloat(y.paddingTop)) * w.y;
      l *= w.x, u *= w.y, c *= w.x, f *= w.y, l += C, u += S, b = ye(m), m = Kr(b);
    }
  }
  return or({
    width: c,
    height: f,
    x: l,
    y: u
  });
}
function mr(e, t) {
  const r = hr(e).scrollLeft;
  return t ? t.left + r : at(We(e)).left + r;
}
function Yi(e, t) {
  const r = e.getBoundingClientRect(), n = r.left + t.scrollLeft - mr(e, r), o = r.top + t.scrollTop;
  return {
    x: n,
    y: o
  };
}
function rf(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: o
  } = e;
  const i = o === "fixed", a = We(n), s = t ? gr(t.floating) : !1;
  if (n === a || s && i)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = je(1);
  const c = je(0), f = Ie(n);
  if ((f || !f && !i) && ((Rt(n) !== "body" || _t(a)) && (l = hr(n)), Ie(n))) {
    const g = at(n);
    u = vt(n), c.x = g.x + n.clientLeft, c.y = g.y + n.clientTop;
  }
  const d = a && !f && !i ? Yi(a, l) : je(0);
  return {
    width: r.width * u.x,
    height: r.height * u.y,
    x: r.x * u.x - l.scrollLeft * u.x + c.x + d.x,
    y: r.y * u.y - l.scrollTop * u.y + c.y + d.y
  };
}
function nf(e) {
  return Array.from(e.getClientRects());
}
function of(e) {
  const t = We(e), r = hr(e), n = e.ownerDocument.body, o = ve(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = ve(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let a = -r.scrollLeft + mr(e);
  const s = -r.scrollTop;
  return Pe(n).direction === "rtl" && (a += ve(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: s
  };
}
const Eo = 25;
function af(e, t) {
  const r = ye(e), n = We(e), o = r.visualViewport;
  let i = n.clientWidth, a = n.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    const c = un();
    (!c || c && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  const u = mr(n);
  if (u <= 0) {
    const c = n.ownerDocument, f = c.body, d = getComputedStyle(f), g = c.compatMode === "CSS1Compat" && parseFloat(d.marginLeft) + parseFloat(d.marginRight) || 0, b = Math.abs(n.clientWidth - f.clientWidth - g);
    b <= Eo && (i -= b);
  } else u <= Eo && (i += u);
  return {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
const sf = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function lf(e, t) {
  const r = at(e, !0, t === "fixed"), n = r.top + e.clientTop, o = r.left + e.clientLeft, i = Ie(e) ? vt(e) : je(1), a = e.clientWidth * i.x, s = e.clientHeight * i.y, l = o * i.x, u = n * i.y;
  return {
    width: a,
    height: s,
    x: l,
    y: u
  };
}
function ko(e, t, r) {
  let n;
  if (t === "viewport")
    n = af(e, r);
  else if (t === "document")
    n = of(We(e));
  else if (Oe(t))
    n = lf(t, r);
  else {
    const o = Ui(e);
    n = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return or(n);
}
function Ki(e, t) {
  const r = Qe(e);
  return r === t || !Oe(r) || bt(r) ? !1 : Pe(r).position === "fixed" || Ki(r, t);
}
function cf(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = Tt(e, [], !1).filter((s) => Oe(s) && Rt(s) !== "body"), o = null;
  const i = Pe(e).position === "fixed";
  let a = i ? Qe(e) : e;
  for (; Oe(a) && !bt(a); ) {
    const s = Pe(a), l = cn(a);
    !l && s.position === "fixed" && (o = null), (i ? !l && !o : !l && s.position === "static" && !!o && sf.has(o.position) || _t(a) && !l && Ki(e, a)) ? n = n.filter((c) => c !== a) : o = s, a = Qe(a);
  }
  return t.set(e, n), n;
}
function uf(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: o
  } = e;
  const a = [...r === "clippingAncestors" ? gr(t) ? [] : cf(t, this._c) : [].concat(r), n], s = a[0], l = a.reduce((u, c) => {
    const f = ko(t, c, o);
    return u.top = ve(f.top, u.top), u.right = Ze(f.right, u.right), u.bottom = Ze(f.bottom, u.bottom), u.left = ve(f.left, u.left), u;
  }, ko(t, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function ff(e) {
  const {
    width: t,
    height: r
  } = Hi(e);
  return {
    width: t,
    height: r
  };
}
function df(e, t, r) {
  const n = Ie(t), o = We(t), i = r === "fixed", a = at(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = je(0);
  function u() {
    l.x = mr(o);
  }
  if (n || !n && !i)
    if ((Rt(t) !== "body" || _t(o)) && (s = hr(t)), n) {
      const g = at(t, !0, i, t);
      l.x = g.x + t.clientLeft, l.y = g.y + t.clientTop;
    } else o && u();
  i && !n && o && u();
  const c = o && !n && !i ? Yi(o, s) : je(0), f = a.left + s.scrollLeft - l.x - c.x, d = a.top + s.scrollTop - l.y - c.y;
  return {
    x: f,
    y: d,
    width: a.width,
    height: a.height
  };
}
function Ir(e) {
  return Pe(e).position === "static";
}
function Ao(e, t) {
  if (!Ie(e) || Pe(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return We(e) === r && (r = r.ownerDocument.body), r;
}
function Gi(e, t) {
  const r = ye(e);
  if (gr(e))
    return r;
  if (!Ie(e)) {
    let o = Qe(e);
    for (; o && !bt(o); ) {
      if (Oe(o) && !Ir(o))
        return o;
      o = Qe(o);
    }
    return r;
  }
  let n = Ao(e, t);
  for (; n && Ku(n) && Ir(n); )
    n = Ao(n, t);
  return n && bt(n) && Ir(n) && !cn(n) ? r : n || Zu(e) || r;
}
const pf = async function(e) {
  const t = this.getOffsetParent || Gi, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: df(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function gf(e) {
  return Pe(e).direction === "rtl";
}
const hf = {
  convertOffsetParentRelativeRectToViewportRelativeRect: rf,
  getDocumentElement: We,
  getClippingRect: uf,
  getOffsetParent: Gi,
  getElementRects: pf,
  getClientRects: nf,
  getDimensions: ff,
  getScale: vt,
  isElement: Oe,
  isRTL: gf
};
function Xi(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function mf(e, t) {
  let r = null, n;
  const o = We(e);
  function i() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: f,
      width: d,
      height: g
    } = u;
    if (s || t(), !d || !g)
      return;
    const b = Kt(f), m = Kt(o.clientWidth - (c + d)), w = Kt(o.clientHeight - (f + g)), v = Kt(c), C = {
      rootMargin: -b + "px " + -m + "px " + -w + "px " + -v + "px",
      threshold: ve(0, Ze(1, l)) || 1
    };
    let S = !0;
    function O(T) {
      const k = T[0].intersectionRatio;
      if (k !== l) {
        if (!S)
          return a();
        k ? a(!1, k) : n = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      k === 1 && !Xi(u, e.getBoundingClientRect()) && a(), S = !1;
    }
    try {
      r = new IntersectionObserver(O, {
        ...C,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(O, C);
    }
    r.observe(e);
  }
  return a(!0), i;
}
function vf(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, u = fn(e), c = o || i ? [...u ? Tt(u) : [], ...Tt(t)] : [];
  c.forEach((v) => {
    o && v.addEventListener("scroll", r, {
      passive: !0
    }), i && v.addEventListener("resize", r);
  });
  const f = u && s ? mf(u, r) : null;
  let d = -1, g = null;
  a && (g = new ResizeObserver((v) => {
    let [y] = v;
    y && y.target === u && g && (g.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var C;
      (C = g) == null || C.observe(t);
    })), r();
  }), u && !l && g.observe(u), g.observe(t));
  let b, m = l ? at(e) : null;
  l && w();
  function w() {
    const v = at(e);
    m && !Xi(m, v) && r(), m = v, b = requestAnimationFrame(w);
  }
  return r(), () => {
    var v;
    c.forEach((y) => {
      o && y.removeEventListener("scroll", r), i && y.removeEventListener("resize", r);
    }), f == null || f(), (v = g) == null || v.disconnect(), g = null, l && cancelAnimationFrame(b);
  };
}
const bf = zu, yf = Bu, wf = Fu, xf = Hu, Sf = $u, To = Mu, Cf = Vu, Rf = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: hf,
    ...r
  }, i = {
    ...o.platform,
    _c: n
  };
  return Iu(e, t, {
    ...o,
    platform: i
  });
};
var Of = typeof document < "u", Pf = function() {
}, qt = Of ? rs : Pf;
function ir(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!ir(e[n], t[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), r = o.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const i = o[n];
      if (!(i === "_owner" && e.$$typeof) && !ir(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ji(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function No(e, t) {
  const r = Ji(e);
  return Math.round(t * r) / r;
}
function Mr(e) {
  const t = p.useRef(e);
  return qt(() => {
    t.current = e;
  }), t;
}
function Ef(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: u
  } = e, [c, f] = p.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [d, g] = p.useState(n);
  ir(d, n) || g(n);
  const [b, m] = p.useState(null), [w, v] = p.useState(null), y = p.useCallback((P) => {
    P !== T.current && (T.current = P, m(P));
  }, []), C = p.useCallback((P) => {
    P !== k.current && (k.current = P, v(P));
  }, []), S = i || b, O = a || w, T = p.useRef(null), k = p.useRef(null), E = p.useRef(c), _ = l != null, j = Mr(l), V = Mr(o), Y = Mr(u), B = p.useCallback(() => {
    if (!T.current || !k.current)
      return;
    const P = {
      placement: t,
      strategy: r,
      middleware: d
    };
    V.current && (P.platform = V.current), Rf(T.current, k.current, P).then((X) => {
      const ne = {
        ...X,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: Y.current !== !1
      };
      I.current && !ir(E.current, ne) && (E.current = ne, Io.flushSync(() => {
        f(ne);
      }));
    });
  }, [d, t, r, V, Y]);
  qt(() => {
    u === !1 && E.current.isPositioned && (E.current.isPositioned = !1, f((P) => ({
      ...P,
      isPositioned: !1
    })));
  }, [u]);
  const I = p.useRef(!1);
  qt(() => (I.current = !0, () => {
    I.current = !1;
  }), []), qt(() => {
    if (S && (T.current = S), O && (k.current = O), S && O) {
      if (j.current)
        return j.current(S, O, B);
      B();
    }
  }, [S, O, B, j, _]);
  const K = p.useMemo(() => ({
    reference: T,
    floating: k,
    setReference: y,
    setFloating: C
  }), [y, C]), F = p.useMemo(() => ({
    reference: S,
    floating: O
  }), [S, O]), $ = p.useMemo(() => {
    const P = {
      position: r,
      left: 0,
      top: 0
    };
    if (!F.floating)
      return P;
    const X = No(F.floating, c.x), ne = No(F.floating, c.y);
    return s ? {
      ...P,
      transform: "translate(" + X + "px, " + ne + "px)",
      ...Ji(F.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: X,
      top: ne
    };
  }, [r, s, F.floating, c.x, c.y]);
  return p.useMemo(() => ({
    ...c,
    update: B,
    refs: K,
    elements: F,
    floatingStyles: $
  }), [c, B, K, F, $]);
}
const kf = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: o
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? To({
        element: n.current,
        padding: o
      }).fn(r) : {} : n ? To({
        element: n,
        padding: o
      }).fn(r) : {};
    }
  };
}, Af = (e, t) => ({
  ...bf(e),
  options: [e, t]
}), Tf = (e, t) => ({
  ...yf(e),
  options: [e, t]
}), Nf = (e, t) => ({
  ...Cf(e),
  options: [e, t]
}), Lf = (e, t) => ({
  ...wf(e),
  options: [e, t]
}), _f = (e, t) => ({
  ...xf(e),
  options: [e, t]
}), jf = (e, t) => ({
  ...Sf(e),
  options: [e, t]
}), Df = (e, t) => ({
  ...kf(e),
  options: [e, t]
});
var If = "Arrow", qi = p.forwardRef((e, t) => {
  const { children: r, width: n = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ x.jsx(
    re.svg,
    {
      ...i,
      ref: t,
      width: n,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ x.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
qi.displayName = If;
var Mf = qi;
function Ff(e) {
  const [t, r] = p.useState(void 0);
  return Ue(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          a = u.inlineSize, s = u.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        r({ width: a, height: s });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
var dn = "Popper", [Zi, Qi] = lr(dn), [$f, ea] = Zi(dn), ta = (e) => {
  const { __scopePopper: t, children: r } = e, [n, o] = p.useState(null);
  return /* @__PURE__ */ x.jsx($f, { scope: t, anchor: n, onAnchorChange: o, children: r });
};
ta.displayName = dn;
var ra = "PopperAnchor", na = p.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: n, ...o } = e, i = ea(ra, r), a = p.useRef(null), s = oe(t, a), l = p.useRef(null);
    return p.useEffect(() => {
      const u = l.current;
      l.current = (n == null ? void 0 : n.current) || a.current, u !== l.current && i.onAnchorChange(l.current);
    }), n ? null : /* @__PURE__ */ x.jsx(re.div, { ...o, ref: s });
  }
);
na.displayName = ra;
var pn = "PopperContent", [Wf, zf] = Zi(pn), oa = p.forwardRef(
  (e, t) => {
    var H, pe, ge, ae, le, he;
    const {
      __scopePopper: r,
      side: n = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: c = 0,
      sticky: f = "partial",
      hideWhenDetached: d = !1,
      updatePositionStrategy: g = "optimized",
      onPlaced: b,
      ...m
    } = e, w = ea(pn, r), [v, y] = p.useState(null), C = oe(t, (Ae) => y(Ae)), [S, O] = p.useState(null), T = Ff(S), k = (T == null ? void 0 : T.width) ?? 0, E = (T == null ? void 0 : T.height) ?? 0, _ = n + (i !== "center" ? "-" + i : ""), j = typeof c == "number" ? c : { top: 0, right: 0, bottom: 0, left: 0, ...c }, V = Array.isArray(u) ? u : [u], Y = V.length > 0, B = {
      padding: j,
      boundary: V.filter(Vf),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: Y
    }, { refs: I, floatingStyles: K, placement: F, isPositioned: $, middlewareData: P } = Ef({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: _,
      whileElementsMounted: (...Ae) => vf(...Ae, {
        animationFrame: g === "always"
      }),
      elements: {
        reference: w.anchor
      },
      middleware: [
        Af({ mainAxis: o + E, alignmentAxis: a }),
        l && Tf({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Nf() : void 0,
          ...B
        }),
        l && Lf({ ...B }),
        _f({
          ...B,
          apply: ({ elements: Ae, rects: tt, availableWidth: st, availableHeight: rt }) => {
            const { width: Dt, height: It } = tt.reference, Be = Ae.floating.style;
            Be.setProperty("--radix-popper-available-width", `${st}px`), Be.setProperty("--radix-popper-available-height", `${rt}px`), Be.setProperty("--radix-popper-anchor-width", `${Dt}px`), Be.setProperty("--radix-popper-anchor-height", `${It}px`);
          }
        }),
        S && Df({ element: S, padding: s }),
        Hf({ arrowWidth: k, arrowHeight: E }),
        d && jf({ strategy: "referenceHidden", ...B })
      ]
    }), [X, ne] = sa(F), ie = be(b);
    Ue(() => {
      $ && (ie == null || ie());
    }, [$, ie]);
    const ke = (H = P.arrow) == null ? void 0 : H.x, q = (pe = P.arrow) == null ? void 0 : pe.y, J = ((ge = P.arrow) == null ? void 0 : ge.centerOffset) !== 0, [Ce, de] = p.useState();
    return Ue(() => {
      v && de(window.getComputedStyle(v).zIndex);
    }, [v]), /* @__PURE__ */ x.jsx(
      "div",
      {
        ref: I.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...K,
          transform: $ ? K.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Ce,
          "--radix-popper-transform-origin": [
            (ae = P.transformOrigin) == null ? void 0 : ae.x,
            (le = P.transformOrigin) == null ? void 0 : le.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((he = P.hide) == null ? void 0 : he.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ x.jsx(
          Wf,
          {
            scope: r,
            placedSide: X,
            onArrowChange: O,
            arrowX: ke,
            arrowY: q,
            shouldHideArrow: J,
            children: /* @__PURE__ */ x.jsx(
              re.div,
              {
                "data-side": X,
                "data-align": ne,
                ...m,
                ref: C,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: $ ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
oa.displayName = pn;
var ia = "PopperArrow", Bf = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, aa = p.forwardRef(function(t, r) {
  const { __scopePopper: n, ...o } = t, i = zf(ia, n), a = Bf[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ x.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ x.jsx(
          Mf,
          {
            ...o,
            ref: r,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
aa.displayName = ia;
function Vf(e) {
  return e !== null;
}
var Hf = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var w, v, y;
    const { placement: r, rects: n, middlewareData: o } = t, a = ((w = o.arrow) == null ? void 0 : w.centerOffset) !== 0, s = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [u, c] = sa(r), f = { start: "0%", center: "50%", end: "100%" }[c], d = (((v = o.arrow) == null ? void 0 : v.x) ?? 0) + s / 2, g = (((y = o.arrow) == null ? void 0 : y.y) ?? 0) + l / 2;
    let b = "", m = "";
    return u === "bottom" ? (b = a ? f : `${d}px`, m = `${-l}px`) : u === "top" ? (b = a ? f : `${d}px`, m = `${n.floating.height + l}px`) : u === "right" ? (b = `${-l}px`, m = a ? f : `${g}px`) : u === "left" && (b = `${n.floating.width + l}px`, m = a ? f : `${g}px`), { data: { x: b, y: m } };
  }
});
function sa(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var Uf = ta, Yf = na, Kf = oa, Gf = aa, [vr, Ud] = lr("Tooltip", [
  Qi
]), br = Qi(), la = "TooltipProvider", Xf = 700, Gr = "tooltip.open", [Jf, gn] = vr(la), ca = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: r = Xf,
    skipDelayDuration: n = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, a = p.useRef(!0), s = p.useRef(!1), l = p.useRef(0);
  return p.useEffect(() => {
    const u = l.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ x.jsx(
    Jf,
    {
      scope: t,
      isOpenDelayedRef: a,
      delayDuration: r,
      onOpen: p.useCallback(() => {
        window.clearTimeout(l.current), a.current = !1;
      }, []),
      onClose: p.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => a.current = !0,
          n
        );
      }, [n]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: p.useCallback((u) => {
        s.current = u;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
ca.displayName = la;
var Nt = "Tooltip", [qf, jt] = vr(Nt), ua = (e) => {
  const {
    __scopeTooltip: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: i,
    disableHoverableContent: a,
    delayDuration: s
  } = e, l = gn(Nt, e.__scopeTooltip), u = br(t), [c, f] = p.useState(null), d = Gt(), g = p.useRef(0), b = a ?? l.disableHoverableContent, m = s ?? l.delayDuration, w = p.useRef(!1), [v, y] = qo({
    prop: n,
    defaultProp: o ?? !1,
    onChange: (k) => {
      k ? (l.onOpen(), document.dispatchEvent(new CustomEvent(Gr))) : l.onClose(), i == null || i(k);
    },
    caller: Nt
  }), C = p.useMemo(() => v ? w.current ? "delayed-open" : "instant-open" : "closed", [v]), S = p.useCallback(() => {
    window.clearTimeout(g.current), g.current = 0, w.current = !1, y(!0);
  }, [y]), O = p.useCallback(() => {
    window.clearTimeout(g.current), g.current = 0, y(!1);
  }, [y]), T = p.useCallback(() => {
    window.clearTimeout(g.current), g.current = window.setTimeout(() => {
      w.current = !0, y(!0), g.current = 0;
    }, m);
  }, [m, y]);
  return p.useEffect(() => () => {
    g.current && (window.clearTimeout(g.current), g.current = 0);
  }, []), /* @__PURE__ */ x.jsx(Uf, { ...u, children: /* @__PURE__ */ x.jsx(
    qf,
    {
      scope: t,
      contentId: d,
      open: v,
      stateAttribute: C,
      trigger: c,
      onTriggerChange: f,
      onTriggerEnter: p.useCallback(() => {
        l.isOpenDelayedRef.current ? T() : S();
      }, [l.isOpenDelayedRef, T, S]),
      onTriggerLeave: p.useCallback(() => {
        b ? O() : (window.clearTimeout(g.current), g.current = 0);
      }, [O, b]),
      onOpen: S,
      onClose: O,
      disableHoverableContent: b,
      children: r
    }
  ) });
};
ua.displayName = Nt;
var Xr = "TooltipTrigger", fa = p.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...n } = e, o = jt(Xr, r), i = gn(Xr, r), a = br(r), s = p.useRef(null), l = oe(t, s, o.onTriggerChange), u = p.useRef(!1), c = p.useRef(!1), f = p.useCallback(() => u.current = !1, []);
    return p.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ x.jsx(Yf, { asChild: !0, ...a, children: /* @__PURE__ */ x.jsx(
      re.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...n,
        ref: l,
        onPointerMove: Q(e.onPointerMove, (d) => {
          d.pointerType !== "touch" && !c.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), c.current = !0);
        }),
        onPointerLeave: Q(e.onPointerLeave, () => {
          o.onTriggerLeave(), c.current = !1;
        }),
        onPointerDown: Q(e.onPointerDown, () => {
          o.open && o.onClose(), u.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: Q(e.onFocus, () => {
          u.current || o.onOpen();
        }),
        onBlur: Q(e.onBlur, o.onClose),
        onClick: Q(e.onClick, o.onClose)
      }
    ) });
  }
);
fa.displayName = Xr;
var hn = "TooltipPortal", [Zf, Qf] = vr(hn, {
  forceMount: void 0
}), da = (e) => {
  const { __scopeTooltip: t, forceMount: r, children: n, container: o } = e, i = jt(hn, t);
  return /* @__PURE__ */ x.jsx(Zf, { scope: t, forceMount: r, children: /* @__PURE__ */ x.jsx(Me, { present: r || i.open, children: /* @__PURE__ */ x.jsx(Qr, { asChild: !0, container: o, children: n }) }) });
};
da.displayName = hn;
var yt = "TooltipContent", pa = p.forwardRef(
  (e, t) => {
    const r = Qf(yt, e.__scopeTooltip), { forceMount: n = r.forceMount, side: o = "top", ...i } = e, a = jt(yt, e.__scopeTooltip);
    return /* @__PURE__ */ x.jsx(Me, { present: n || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ x.jsx(ga, { side: o, ...i, ref: t }) : /* @__PURE__ */ x.jsx(ed, { side: o, ...i, ref: t }) });
  }
), ed = p.forwardRef((e, t) => {
  const r = jt(yt, e.__scopeTooltip), n = gn(yt, e.__scopeTooltip), o = p.useRef(null), i = oe(t, o), [a, s] = p.useState(null), { trigger: l, onClose: u } = r, c = o.current, { onPointerInTransitChange: f } = n, d = p.useCallback(() => {
    s(null), f(!1);
  }, [f]), g = p.useCallback(
    (b, m) => {
      const w = b.currentTarget, v = { x: b.clientX, y: b.clientY }, y = od(v, w.getBoundingClientRect()), C = id(v, y), S = ad(m.getBoundingClientRect()), O = ld([...C, ...S]);
      s(O), f(!0);
    },
    [f]
  );
  return p.useEffect(() => () => d(), [d]), p.useEffect(() => {
    if (l && c) {
      const b = (w) => g(w, c), m = (w) => g(w, l);
      return l.addEventListener("pointerleave", b), c.addEventListener("pointerleave", m), () => {
        l.removeEventListener("pointerleave", b), c.removeEventListener("pointerleave", m);
      };
    }
  }, [l, c, g, d]), p.useEffect(() => {
    if (a) {
      const b = (m) => {
        const w = m.target, v = { x: m.clientX, y: m.clientY }, y = (l == null ? void 0 : l.contains(w)) || (c == null ? void 0 : c.contains(w)), C = !sd(v, a);
        y ? d() : C && (d(), u());
      };
      return document.addEventListener("pointermove", b), () => document.removeEventListener("pointermove", b);
    }
  }, [l, c, a, u, d]), /* @__PURE__ */ x.jsx(ga, { ...e, ref: i });
}), [td, rd] = vr(Nt, { isInside: !1 }), nd = /* @__PURE__ */ cs("TooltipContent"), ga = p.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: r,
      children: n,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      ...s
    } = e, l = jt(yt, r), u = br(r), { onClose: c } = l;
    return p.useEffect(() => (document.addEventListener(Gr, c), () => document.removeEventListener(Gr, c)), [c]), p.useEffect(() => {
      if (l.trigger) {
        const f = (d) => {
          const g = d.target;
          g != null && g.contains(l.trigger) && c();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [l.trigger, c]), /* @__PURE__ */ x.jsx(
      Zr,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: a,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: c,
        children: /* @__PURE__ */ x.jsxs(
          Kf,
          {
            "data-state": l.stateAttribute,
            ...u,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ x.jsx(nd, { children: n }),
              /* @__PURE__ */ x.jsx(td, { scope: r, isInside: !0, children: /* @__PURE__ */ x.jsx(jc, { id: l.contentId, role: "tooltip", children: o || n }) })
            ]
          }
        )
      }
    );
  }
);
pa.displayName = yt;
var ha = "TooltipArrow", ma = p.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...n } = e, o = br(r);
    return rd(
      ha,
      r
    ).isInside ? null : /* @__PURE__ */ x.jsx(Gf, { ...o, ...n, ref: t });
  }
);
ma.displayName = ha;
function od(e, t) {
  const r = Math.abs(t.top - e.y), n = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(r, n, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case r:
      return "top";
    case n:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function id(e, t, r = 5) {
  const n = [];
  switch (t) {
    case "top":
      n.push(
        { x: e.x - r, y: e.y + r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "bottom":
      n.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x + r, y: e.y - r }
      );
      break;
    case "left":
      n.push(
        { x: e.x + r, y: e.y - r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "right":
      n.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x - r, y: e.y + r }
      );
      break;
  }
  return n;
}
function ad(e) {
  const { top: t, right: r, bottom: n, left: o } = e;
  return [
    { x: o, y: t },
    { x: r, y: t },
    { x: r, y: n },
    { x: o, y: n }
  ];
}
function sd(e, t) {
  const { x: r, y: n } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i], l = t[a], u = s.x, c = s.y, f = l.x, d = l.y;
    c > n != d > n && r < (f - u) * (n - c) / (d - c) + u && (o = !o);
  }
  return o;
}
function ld(e) {
  const t = e.slice();
  return t.sort((r, n) => r.x < n.x ? -1 : r.x > n.x ? 1 : r.y < n.y ? -1 : r.y > n.y ? 1 : 0), cd(t);
}
function cd(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], a = t[t.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const r = [];
  for (let n = e.length - 1; n >= 0; n--) {
    const o = e[n];
    for (; r.length >= 2; ) {
      const i = r[r.length - 1], a = r[r.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) r.pop();
      else break;
    }
    r.push(o);
  }
  return r.pop(), t.length === 1 && r.length === 1 && t[0].x === r[0].x && t[0].y === r[0].y ? t : t.concat(r);
}
var ud = ca, fd = ua, dd = fa, pd = da, gd = pa, hd = ma;
function va({
  delayDuration: e = 0,
  disableHoverableContent: t = !1,
  ...r
}) {
  return /* @__PURE__ */ x.jsx(
    ud,
    {
      "data-slot": "tooltip-provider",
      delayDuration: e,
      disableHoverableContent: t,
      ...r
    }
  );
}
function md({
  disabled: e = !1,
  ...t
}) {
  return /* @__PURE__ */ x.jsx(va, { disableHoverableContent: !0, children: /* @__PURE__ */ x.jsx(
    fd,
    {
      "data-slot": "tooltip",
      open: e ? !1 : void 0,
      ...t
    }
  ) });
}
function vd({
  ...e
}) {
  return /* @__PURE__ */ x.jsx(
    dd,
    {
      "data-slot": "tooltip-trigger",
      onClick: (t) => {
        var r;
        (r = e.onClick) == null || r.call(e, t);
      },
      ...e
    }
  );
}
function bd({
  className: e,
  sideOffset: t = 0,
  children: r,
  variant: n = "light",
  container: o,
  ...i
}) {
  return /* @__PURE__ */ x.jsx(pd, { container: o, children: /* @__PURE__ */ x.jsxs(
    gd,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: ue(
        `animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out
          data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95
          data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2
          data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2
          origin-(--radix-tooltip-content-transform-origin) z-50 w-fit text-balance rounded-md px-4
          py-2 text-sm font-medium`,
        {
          "text-dark bg-white shadow-[0_0_10px_0_rgba(143,143,143,0.30)]": n === "light",
          "bg-dark text-dark-foreground": n === "dark"
        },
        e
      ),
      ...i,
      children: [
        r,
        /* @__PURE__ */ x.jsx(
          hd,
          {
            className: ue(
              "z-50 size-3 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]",
              {
                "bg-white fill-white": n === "light",
                "bg-dark fill-dark": n === "dark"
              }
            )
          }
        )
      ]
    }
  ) });
}
function Yd({
  content: e,
  variant: t,
  side: r,
  onClick: n,
  contentClassName: o,
  className: i
}) {
  var u;
  const [a, s] = jo(!1), l = (c) => {
    c.stopPropagation(), s((f) => !f), n == null || n(c);
  };
  return /* @__PURE__ */ x.jsx(va, { disableHoverableContent: !0, children: /* @__PURE__ */ x.jsxs(md, { open: a, onOpenChange: s, children: [
    /* @__PURE__ */ x.jsx(vd, { asChild: !0, onClick: l, children: /* @__PURE__ */ x.jsxs(
      "div",
      {
        className: ue(
          "relative flex h-4 w-4 cursor-help items-center justify-center hover:text-primary",
          i
        ),
        children: [
          /* @__PURE__ */ x.jsx(Ac, {}),
          /* @__PURE__ */ x.jsx("div", { className: "absolute -left-0.5 -top-0.5 h-5 w-5" })
        ]
      }
    ) }),
    /* @__PURE__ */ x.jsx(
      bd,
      {
        variant: t,
        side: r,
        className: ue("max-w-64", o),
        container: (u = window.chekinCustomDocument) == null ? void 0 : u.body,
        onPointerDownOutside: () => s(!1),
        children: e
      }
    )
  ] }) });
}
var yd = p.createContext(void 0);
function wd(e) {
  const t = p.useContext(yd);
  return e || t || "ltr";
}
function xd(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
function Sd(e, t) {
  return p.useReducer((r, n) => t[r][n] ?? r, e);
}
var mn = "ScrollArea", [ba, Kd] = lr(mn), [Cd, Se] = ba(mn), ya = p.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: r,
      type: n = "hover",
      dir: o,
      scrollHideDelay: i = 600,
      ...a
    } = e, [s, l] = p.useState(null), [u, c] = p.useState(null), [f, d] = p.useState(null), [g, b] = p.useState(null), [m, w] = p.useState(null), [v, y] = p.useState(0), [C, S] = p.useState(0), [O, T] = p.useState(!1), [k, E] = p.useState(!1), _ = oe(t, (V) => l(V)), j = wd(o);
    return /* @__PURE__ */ x.jsx(
      Cd,
      {
        scope: r,
        type: n,
        dir: j,
        scrollHideDelay: i,
        scrollArea: s,
        viewport: u,
        onViewportChange: c,
        content: f,
        onContentChange: d,
        scrollbarX: g,
        onScrollbarXChange: b,
        scrollbarXEnabled: O,
        onScrollbarXEnabledChange: T,
        scrollbarY: m,
        onScrollbarYChange: w,
        scrollbarYEnabled: k,
        onScrollbarYEnabledChange: E,
        onCornerWidthChange: y,
        onCornerHeightChange: S,
        children: /* @__PURE__ */ x.jsx(
          re.div,
          {
            dir: j,
            ...a,
            ref: _,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": v + "px",
              "--radix-scroll-area-corner-height": C + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
ya.displayName = mn;
var wa = "ScrollAreaViewport", xa = p.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, children: n, nonce: o, ...i } = e, a = Se(wa, r), s = p.useRef(null), l = oe(t, s, a.onViewportChange);
    return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ x.jsx(
        re.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...i,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ x.jsx("div", { ref: a.onContentChange, style: { minWidth: "100%", display: "table" }, children: n })
        }
      )
    ] });
  }
);
xa.displayName = wa;
var ze = "ScrollAreaScrollbar", Sa = p.forwardRef(
  (e, t) => {
    const { forceMount: r, ...n } = e, o = Se(ze, e.__scopeScrollArea), { onScrollbarXEnabledChange: i, onScrollbarYEnabledChange: a } = o, s = e.orientation === "horizontal";
    return p.useEffect(() => (s ? i(!0) : a(!0), () => {
      s ? i(!1) : a(!1);
    }), [s, i, a]), o.type === "hover" ? /* @__PURE__ */ x.jsx(Rd, { ...n, ref: t, forceMount: r }) : o.type === "scroll" ? /* @__PURE__ */ x.jsx(Od, { ...n, ref: t, forceMount: r }) : o.type === "auto" ? /* @__PURE__ */ x.jsx(Ca, { ...n, ref: t, forceMount: r }) : o.type === "always" ? /* @__PURE__ */ x.jsx(vn, { ...n, ref: t }) : null;
  }
);
Sa.displayName = ze;
var Rd = p.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, o = Se(ze, e.__scopeScrollArea), [i, a] = p.useState(!1);
  return p.useEffect(() => {
    const s = o.scrollArea;
    let l = 0;
    if (s) {
      const u = () => {
        window.clearTimeout(l), a(!0);
      }, c = () => {
        l = window.setTimeout(() => a(!1), o.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", u), s.addEventListener("pointerleave", c), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", u), s.removeEventListener("pointerleave", c);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), /* @__PURE__ */ x.jsx(Me, { present: r || i, children: /* @__PURE__ */ x.jsx(
    Ca,
    {
      "data-state": i ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), Od = p.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, o = Se(ze, e.__scopeScrollArea), i = e.orientation === "horizontal", a = wr(() => l("SCROLL_END"), 100), [s, l] = Sd("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return p.useEffect(() => {
    if (s === "idle") {
      const u = window.setTimeout(() => l("HIDE"), o.scrollHideDelay);
      return () => window.clearTimeout(u);
    }
  }, [s, o.scrollHideDelay, l]), p.useEffect(() => {
    const u = o.viewport, c = i ? "scrollLeft" : "scrollTop";
    if (u) {
      let f = u[c];
      const d = () => {
        const g = u[c];
        f !== g && (l("SCROLL"), a()), f = g;
      };
      return u.addEventListener("scroll", d), () => u.removeEventListener("scroll", d);
    }
  }, [o.viewport, i, l, a]), /* @__PURE__ */ x.jsx(Me, { present: r || s !== "hidden", children: /* @__PURE__ */ x.jsx(
    vn,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...n,
      ref: t,
      onPointerEnter: Q(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: Q(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Ca = p.forwardRef((e, t) => {
  const r = Se(ze, e.__scopeScrollArea), { forceMount: n, ...o } = e, [i, a] = p.useState(!1), s = e.orientation === "horizontal", l = wr(() => {
    if (r.viewport) {
      const u = r.viewport.offsetWidth < r.viewport.scrollWidth, c = r.viewport.offsetHeight < r.viewport.scrollHeight;
      a(s ? u : c);
    }
  }, 10);
  return wt(r.viewport, l), wt(r.content, l), /* @__PURE__ */ x.jsx(Me, { present: n || i, children: /* @__PURE__ */ x.jsx(
    vn,
    {
      "data-state": i ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), vn = p.forwardRef((e, t) => {
  const { orientation: r = "vertical", ...n } = e, o = Se(ze, e.__scopeScrollArea), i = p.useRef(null), a = p.useRef(0), [s, l] = p.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), u = ka(s.viewport, s.content), c = {
    ...n,
    sizes: s,
    onSizesChange: l,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (d) => i.current = d,
    onThumbPointerUp: () => a.current = 0,
    onThumbPointerDown: (d) => a.current = d
  };
  function f(d, g) {
    return Nd(d, a.current, s, g);
  }
  return r === "horizontal" ? /* @__PURE__ */ x.jsx(
    Pd,
    {
      ...c,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const d = o.viewport.scrollLeft, g = Lo(d, s, o.dir);
          i.current.style.transform = `translate3d(${g}px, 0, 0)`;
        }
      },
      onWheelScroll: (d) => {
        o.viewport && (o.viewport.scrollLeft = d);
      },
      onDragScroll: (d) => {
        o.viewport && (o.viewport.scrollLeft = f(d, o.dir));
      }
    }
  ) : r === "vertical" ? /* @__PURE__ */ x.jsx(
    Ed,
    {
      ...c,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && i.current) {
          const d = o.viewport.scrollTop, g = Lo(d, s);
          i.current.style.transform = `translate3d(0, ${g}px, 0)`;
        }
      },
      onWheelScroll: (d) => {
        o.viewport && (o.viewport.scrollTop = d);
      },
      onDragScroll: (d) => {
        o.viewport && (o.viewport.scrollTop = f(d));
      }
    }
  ) : null;
}), Pd = p.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: n, ...o } = e, i = Se(ze, e.__scopeScrollArea), [a, s] = p.useState(), l = p.useRef(null), u = oe(t, l, i.onScrollbarXChange);
  return p.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ x.jsx(
    Oa,
    {
      "data-orientation": "horizontal",
      ...o,
      ref: u,
      sizes: r,
      style: {
        bottom: 0,
        left: i.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: i.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": yr(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (c) => e.onThumbPointerDown(c.x),
      onDragScroll: (c) => e.onDragScroll(c.x),
      onWheelScroll: (c, f) => {
        if (i.viewport) {
          const d = i.viewport.scrollLeft + c.deltaX;
          e.onWheelScroll(d), Ta(d, f) && c.preventDefault();
        }
      },
      onResize: () => {
        l.current && i.viewport && a && n({
          content: i.viewport.scrollWidth,
          viewport: i.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: sr(a.paddingLeft),
            paddingEnd: sr(a.paddingRight)
          }
        });
      }
    }
  );
}), Ed = p.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: n, ...o } = e, i = Se(ze, e.__scopeScrollArea), [a, s] = p.useState(), l = p.useRef(null), u = oe(t, l, i.onScrollbarYChange);
  return p.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ x.jsx(
    Oa,
    {
      "data-orientation": "vertical",
      ...o,
      ref: u,
      sizes: r,
      style: {
        top: 0,
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": yr(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (c) => e.onThumbPointerDown(c.y),
      onDragScroll: (c) => e.onDragScroll(c.y),
      onWheelScroll: (c, f) => {
        if (i.viewport) {
          const d = i.viewport.scrollTop + c.deltaY;
          e.onWheelScroll(d), Ta(d, f) && c.preventDefault();
        }
      },
      onResize: () => {
        l.current && i.viewport && a && n({
          content: i.viewport.scrollHeight,
          viewport: i.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: sr(a.paddingTop),
            paddingEnd: sr(a.paddingBottom)
          }
        });
      }
    }
  );
}), [kd, Ra] = ba(ze), Oa = p.forwardRef((e, t) => {
  const {
    __scopeScrollArea: r,
    sizes: n,
    hasThumb: o,
    onThumbChange: i,
    onThumbPointerUp: a,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: u,
    onWheelScroll: c,
    onResize: f,
    ...d
  } = e, g = Se(ze, r), [b, m] = p.useState(null), w = oe(t, (_) => m(_)), v = p.useRef(null), y = p.useRef(""), C = g.viewport, S = n.content - n.viewport, O = be(c), T = be(l), k = wr(f, 10);
  function E(_) {
    if (v.current) {
      const j = _.clientX - v.current.left, V = _.clientY - v.current.top;
      u({ x: j, y: V });
    }
  }
  return p.useEffect(() => {
    const _ = (j) => {
      const V = j.target;
      (b == null ? void 0 : b.contains(V)) && O(j, S);
    };
    return document.addEventListener("wheel", _, { passive: !1 }), () => document.removeEventListener("wheel", _, { passive: !1 });
  }, [C, b, S, O]), p.useEffect(T, [n, T]), wt(b, k), wt(g.content, k), /* @__PURE__ */ x.jsx(
    kd,
    {
      scope: r,
      scrollbar: b,
      hasThumb: o,
      onThumbChange: be(i),
      onThumbPointerUp: be(a),
      onThumbPositionChange: T,
      onThumbPointerDown: be(s),
      children: /* @__PURE__ */ x.jsx(
        re.div,
        {
          ...d,
          ref: w,
          style: { position: "absolute", ...d.style },
          onPointerDown: Q(e.onPointerDown, (_) => {
            _.button === 0 && (_.target.setPointerCapture(_.pointerId), v.current = b.getBoundingClientRect(), y.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", g.viewport && (g.viewport.style.scrollBehavior = "auto"), E(_));
          }),
          onPointerMove: Q(e.onPointerMove, E),
          onPointerUp: Q(e.onPointerUp, (_) => {
            const j = _.target;
            j.hasPointerCapture(_.pointerId) && j.releasePointerCapture(_.pointerId), document.body.style.webkitUserSelect = y.current, g.viewport && (g.viewport.style.scrollBehavior = ""), v.current = null;
          })
        }
      )
    }
  );
}), ar = "ScrollAreaThumb", Pa = p.forwardRef(
  (e, t) => {
    const { forceMount: r, ...n } = e, o = Ra(ar, e.__scopeScrollArea);
    return /* @__PURE__ */ x.jsx(Me, { present: r || o.hasThumb, children: /* @__PURE__ */ x.jsx(Ad, { ref: t, ...n }) });
  }
), Ad = p.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, style: n, ...o } = e, i = Se(ar, r), a = Ra(ar, r), { onThumbPositionChange: s } = a, l = oe(
      t,
      (f) => a.onThumbChange(f)
    ), u = p.useRef(void 0), c = wr(() => {
      u.current && (u.current(), u.current = void 0);
    }, 100);
    return p.useEffect(() => {
      const f = i.viewport;
      if (f) {
        const d = () => {
          if (c(), !u.current) {
            const g = Ld(f, s);
            u.current = g, s();
          }
        };
        return s(), f.addEventListener("scroll", d), () => f.removeEventListener("scroll", d);
      }
    }, [i.viewport, c, s]), /* @__PURE__ */ x.jsx(
      re.div,
      {
        "data-state": a.hasThumb ? "visible" : "hidden",
        ...o,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...n
        },
        onPointerDownCapture: Q(e.onPointerDownCapture, (f) => {
          const g = f.target.getBoundingClientRect(), b = f.clientX - g.left, m = f.clientY - g.top;
          a.onThumbPointerDown({ x: b, y: m });
        }),
        onPointerUp: Q(e.onPointerUp, a.onThumbPointerUp)
      }
    );
  }
);
Pa.displayName = ar;
var bn = "ScrollAreaCorner", Ea = p.forwardRef(
  (e, t) => {
    const r = Se(bn, e.__scopeScrollArea), n = !!(r.scrollbarX && r.scrollbarY);
    return r.type !== "scroll" && n ? /* @__PURE__ */ x.jsx(Td, { ...e, ref: t }) : null;
  }
);
Ea.displayName = bn;
var Td = p.forwardRef((e, t) => {
  const { __scopeScrollArea: r, ...n } = e, o = Se(bn, r), [i, a] = p.useState(0), [s, l] = p.useState(0), u = !!(i && s);
  return wt(o.scrollbarX, () => {
    var f;
    const c = ((f = o.scrollbarX) == null ? void 0 : f.offsetHeight) || 0;
    o.onCornerHeightChange(c), l(c);
  }), wt(o.scrollbarY, () => {
    var f;
    const c = ((f = o.scrollbarY) == null ? void 0 : f.offsetWidth) || 0;
    o.onCornerWidthChange(c), a(c);
  }), u ? /* @__PURE__ */ x.jsx(
    re.div,
    {
      ...n,
      ref: t,
      style: {
        width: i,
        height: s,
        position: "absolute",
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function sr(e) {
  return e ? parseInt(e, 10) : 0;
}
function ka(e, t) {
  const r = e / t;
  return isNaN(r) ? 0 : r;
}
function yr(e) {
  const t = ka(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, n = (e.scrollbar.size - r) * t;
  return Math.max(n, 18);
}
function Nd(e, t, r, n = "ltr") {
  const o = yr(r), i = o / 2, a = t || i, s = o - a, l = r.scrollbar.paddingStart + a, u = r.scrollbar.size - r.scrollbar.paddingEnd - s, c = r.content - r.viewport, f = n === "ltr" ? [0, c] : [c * -1, 0];
  return Aa([l, u], f)(e);
}
function Lo(e, t, r = "ltr") {
  const n = yr(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, i = t.scrollbar.size - o, a = t.content - t.viewport, s = i - n, l = r === "ltr" ? [0, a] : [a * -1, 0], u = xd(e, l);
  return Aa([0, a], [0, s])(u);
}
function Aa(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (r - e[0]);
  };
}
function Ta(e, t) {
  return e > 0 && e < t;
}
var Ld = (e, t = () => {
}) => {
  let r = { left: e.scrollLeft, top: e.scrollTop }, n = 0;
  return (function o() {
    const i = { left: e.scrollLeft, top: e.scrollTop }, a = r.left !== i.left, s = r.top !== i.top;
    (a || s) && t(), r = i, n = window.requestAnimationFrame(o);
  })(), () => window.cancelAnimationFrame(n);
};
function wr(e, t) {
  const r = be(e), n = p.useRef(0);
  return p.useEffect(() => () => window.clearTimeout(n.current), []), p.useCallback(() => {
    window.clearTimeout(n.current), n.current = window.setTimeout(r, t);
  }, [r, t]);
}
function wt(e, t) {
  const r = be(t);
  Ue(() => {
    let n = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(n), n = window.requestAnimationFrame(r);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(n), o.unobserve(e);
      };
    }
  }, [e, r]);
}
var _d = ya, jd = xa, Dd = Ea;
const Id = p.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ x.jsxs(
  _d,
  {
    ref: n,
    "data-slot": "scroll-area",
    className: ue("relative", e),
    ...r,
    children: [
      /* @__PURE__ */ x.jsx(
        jd,
        {
          "data-slot": "scroll-area-viewport",
          className: "focus-visible:ring-ring/50 size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:outline-1 [&>div]:!block",
          children: t
        }
      ),
      /* @__PURE__ */ x.jsx(Na, {}),
      /* @__PURE__ */ x.jsx(Dd, {})
    ]
  }
));
Id.displayName = "ScrollArea";
const Na = p.forwardRef(({ className: e, orientation: t = "vertical", ...r }, n) => /* @__PURE__ */ x.jsx(
  Sa,
  {
    ref: n,
    "data-slot": "scroll-area-scrollbar",
    orientation: t,
    className: ue(
      "flex touch-none p-px transition-colors select-none  z-[6]",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent",
      e
    ),
    ...r,
    children: /* @__PURE__ */ x.jsx(
      Pa,
      {
        "data-slot": "scroll-area-thumb",
        className: "bg-[#0000004d] relative flex-1 rounded-full"
      }
    )
  }
));
Na.displayName = "ScrollBar";
const Gd = ({ children: e, container: t }) => /* @__PURE__ */ x.jsx(Mi.Provider, { value: { container: t }, children: e });
export {
  Xs as Button,
  zd as Dialog,
  Vd as DialogClose,
  yu as DialogContent,
  Cu as DialogDescription,
  xu as DialogFooter,
  wu as DialogHeader,
  $i as DialogOverlay,
  bu as DialogPortal,
  Gd as DialogProvider,
  Su as DialogTitle,
  Bd as DialogTrigger,
  Ru as DialogVisuallyHidden,
  Id as ScrollArea,
  Na as ScrollBar,
  Hd as Skeleton,
  md as Tooltip,
  bd as TooltipContent,
  Yd as TooltipInfo,
  va as TooltipProvider,
  vd as TooltipTrigger
};
//# sourceMappingURL=index.js.map
